export const translations = {
  fr: {
    nav: { home: "Accueil", catalogue: "La Boutique", catalogues: "Les Catalogues", plaquettes: "Gravure sur mesure", forfaits: "Forfaits Tournoi", blog: "Blogue", craft: "Savoir-faire", realisations: "Réalisations", about: "À propos", faq: "FAQ", rdv: "Rendez-vous", contact: "Contact", login: "Connexion", account: "Mon compte", admin: "Administration", logout: "Déconnexion" },
    rdv: {
      kicker: "Rendez-vous", title_1: "Prendre", title_2: "rendez-vous",
      sub: "Réservez un moment avec nous — décrivez votre besoin, choisissez la date et l'heure pendant les heures d'ouverture. Une confirmation vous est envoyée par courriel.",
      need_account_title: "Un compte complet est requis",
      need_account_sub: "Pour réserver, créez votre compte avec votre nom, votre adresse, votre numéro de téléphone et votre courriel — cela prend moins d'une minute.",
      register: "Créer mon compte", login: "J'ai déjà un compte",
      complete_profile: "Il manque des informations à votre compte (adresse ou téléphone) pour réserver.",
      complete_profile_link: "Compléter mon compte",
      type_title: "Besoin de parler à quelqu'un ? Enregistrez-vous ici.",
      type_libre_placeholder: "Ex. : visite en boutique, appel téléphonique, gravure urgente…",
      type_libre_hint: "écrivez ce qui vous convient",
      type_requis: "Écrivez d'abord votre type de rendez-vous à l'étape 1 pour confirmer.",
      type_requis_court: "Votre type de rendez-vous",
      type_boutique: "Visite en boutique", type_boutique_sub: "Venez nous voir — nous préparons vos idées et échantillons.",
      type_tel: "Appel téléphonique", type_tel_sub: "Nous vous appelons au numéro de votre compte.",
      date_title: "Choisissez la date",
      slot_title: "Choisissez l'heure", minutes: "15 minutes",
      no_slots: "La boutique est fermée ce jour-là — essayez une autre date.",
      ferme_inactif: "Les réservations en ligne sont fermées pour le moment — écrivez-nous sur Messenger ou appelez-nous.",
      ferme_note: "Fermé ce jour-là",
      libre: "Libre", occupe: "Occupé", mien: "Votre rendez-vous", mien_court: "À vous",
      sujet_label: "Sujet de la visite (optionnel)",
      sujet_placeholder: "Ex. : 40 médailles de soccer pour un tournoi…",
      confirm_btn: "Confirmer le rendez-vous", confirming: "Confirmation…",
      address_shop: "1314 ch. du Lac-Saint-Louis, Léry QC",
      tel_note: "Nous vous appellerons au",
      success_title: "Rendez-vous confirmé !",
      success_sub: "Un courriel de confirmation vous a été envoyé et le rendez-vous est inscrit à notre agenda.",
      another: "Prendre un autre rendez-vous",
      my_rdv: "Mes rendez-vous à venir", cancel: "Annuler", cancelled: "Rendez-vous annulé.",
    },
    blog: {
      kicker: "Le blogue de l'atelier", title_1: "Idées et", title_2: "conseils",
      seo_title: "Blogue — Idées et conseils sur les trophées personnalisés | Mr Trophée",
      seo_desc: "Conseils, idées de reconnaissance et coulisses de l'atelier : tout sur les trophées, médailles et gravures personnalisées au Québec.",
      read_more: "Lire l'article", empty: "Aucun article publié pour l'instant — revenez bientôt !",
      loading: "Chargement des articles…", not_found: "Article introuvable.", back: "Retour au blogue",
      share: "Partager cet article", share_facebook: "Partager sur Facebook", share_email: "Partager par courriel",
      share_email_hint: "Votre logiciel courriel s'ouvre — sinon le texte est copié : collez-le dans un nouveau message",
      share_copy: "Copier le lien", share_copied: "Lien copié !", share_sms: "Partager par texto",
      share_native: "Partager…",
      share_messenger: "Écrivez-nous sur Messenger",
      related: "À lire aussi",
      shop_title: "Nos vedettes du moment",
      shop_cta: "Voir toute la boutique",
    },
    seo: {
      home_title: "Mr Trophée — Trophées, médailles et plaques au Québec",
      home_desc: "Trophées, médailles et plaques personnalisés au Québec. Gravure laser et impression couleur, prix dégressifs, livraison ou ramassage. Meilleur prix garanti.",
      catalogue_title: "Achat en ligne — Trophées, coupes, médailles et plaques | Mr Trophée",
      catalogue_desc: "Parcourez nos trophées et récompenses personnalisables : grandeur, quantité et gravure au choix, avec prix dégressifs selon la quantité.",
      catalogues_title: "Catalogues en ligne de nos fournisseurs | Mr Trophée",
      catalogues_desc: "Consultez les catalogues complets de nos fournisseurs — médailles, composantes, plaques et plus — et demandez une soumission sur mesure.",
      realisations_title: "Nos réalisations — Gravures et trophées sur mesure | Mr Trophée",
      realisations_desc: "Trophées gravés, plaques honorifiques et récompenses personnalisées pour entreprises, municipalités et organisations sportives.",
      about_title: "À propos — Trophées, gravure laser, sérigraphie et 21 services d'atelier à Léry | Mr Trophée",
      about_desc: "Mr Trophée à Léry (Montérégie) : trophées, médailles, plaques, gravure laser et CNC, sérigraphie, affichage grand format et 15 autres services. Meilleur prix garanti au Canada.",
      faq_title: "FAQ — Questions fréquentes | Mr Trophée",
      faq_desc: "Délais, gravure laser, impression couleur, livraison express et prix dégressifs : toutes les réponses sur vos trophées personnalisés.",
      contact_title: "Contact — Mr Trophée à Léry, Québec",
      contact_desc: "Contactez Mr Trophée : 1314 ch. du Lac-Saint-Louis, Léry (Québec). +1 514-565-6665. Réponse même en dehors des heures d'ouverture.",
      product_suffix: "| Mr Trophée",
    },
    footer: {
      tagline: "Des récompenses d'exception au meilleur prix garanti au Canada. Gravure de haute précision pour entreprises, municipalités et organisations sportives.",
      nav_title: "Navigation", contact_title: "Nous joindre",
      catalogue: "La Boutique", cart: "Panier", account: "Mon compte", register: "Créer un compte", catalogues: "Les Catalogues",
      occasions: "Par occasion", villes: "Par ville", livraison: "Livraison en main propre", referral: "Parrainage", badge: "Badge partenaire",
      location: "1314 ch. du Lac-Saint-Louis, Léry (Québec) J6N 1B1",
      phone: "+1 514-565-6665",
      texto: "Texto",
      hours: "Réponse même en dehors des heures d'ouverture",
      rights: "Trophées, médailles, plaques et gravures sur mesure.",
      share_page: "Partager cette page",
    },
    ribbon: ["Gravure laser haute précision", "Trophées", "Médailles", "Plaques honorifiques", "Impression couleur", "Meilleur prix garanti au Canada", "Service bilingue"],
    home: {
      hero_kicker: "Montérégie · Québec — Atelier de reconnaissance",
      back_kicker: "Bon retour parmi nous",
      back_new: "Depuis votre dernière visite",
      back_products: "nouveaux produits en boutique",
      back_read: "Lire la nouveauté",
      back_shop: "Voir la boutique",
      back_hide: "Ne plus afficher",
      hero_l1: "L'art de", hero_l2: "la victoire,", hero_l3: "gravé à jamais.",
      hero_sub: "Trophées, médailles et plaques personnalisés pour vos compétitions, vos équipes sportives et vos entreprises. Choisissez la grandeur, la quantité, puis votre inscription gravée ou imprimée.",
      cta_collection: "Découvrir La Boutique", cta_craft: "Notre savoir-faire",
      cta_catalogues: "Consulter nos catalogues en ligne",
      collection_kicker: "La collection", collection_title_1: "Des récompenses", collection_title_2: "d'exception",
      pet_tags_kicker: "Nouveau — pour vos compagnons",
      pet_tags_title_1: "Plaques d'identification", pet_tags_title_2: "pour animaux",
      pet_tags_desc: "Patte, tête de chien ou os Élégance — couleurs vives et finis pailletés, gravure personnalisée jusqu'à 4 lignes. Anneau ou chaîne inclus.",
      pet_tags_price_from: "Dès 14,99 $",
      pet_tags_price_note: "— gravure : à déterminer",
      pet_tags_cta: "Personnaliser la plaque",
      see_all: "Voir tout le catalogue", from: "dès",
      craft_kicker: "Personnalisation",
      craft_title_1: "Votre inscription,", craft_title_2: "validée par l'atelier.",
      craft_cta: "Personnaliser un trophée",
      craft_plate: "Champions 2026 — Ligue Élite",
      final_title_1: "Prêt à honorer", final_title_2: "vos champions ?",
      final_sub: "Prix dégressifs selon la quantité, livraison partout au Canada.",
      final_cta: "Commander maintenant",
      // Section « L'atelier » (2026-10-28, audit SEO « contenu mince ») — ses
      // mots à lui, modifiables en mode « page Word » dans l'aperçu admin
      atelier_kicker: "L'atelier — Léry, Montérégie",
      atelier_title_1: "Un atelier québécois,",
      atelier_title_2: "des trophées qui racontent",
      atelier_p1: "Depuis 2002, Mr Trophée grave les grandes étapes des équipes, des écoles et des entreprises d'ici. Trophées, coupes, médailles, plaques honorifiques : chaque pièce est préparée dans notre atelier de Léry, en Montérégie, avec le même soin — que ce soit pour le tournoi de hockey d'un week-end ou le gala d'une grande entreprise.",
      atelier_p2: "Gravure laser d'une précision au dixième de millimètre sur métal, verre et bois, impression couleur fidèle à vos couleurs, prix dégressifs selon la quantité : vous nous envoyez votre texte et votre logo, nous faisons le reste. Ramassage à Léry, à Châteauguay ou dans la région, et livraison partout au Canada.",
      atelier_p3: "Notre promesse tient en trois mots : meilleur prix garanti au Canada, service bilingue, réponse d'humain à humain — une soumission en 30 secondes, et on s'occupe de tout.",
      chapters: [
        { num: "01", title: "La matière", text: "Métal finition or, cristal taillé, bois de noyer massif. Chaque récompense commence par un matériau noble, choisi pour durer aussi longtemps que le souvenir qu'elle célèbre." },
        { num: "02", title: "La gravure", text: "Gravure laser haute précision ou impression couleur spécialisée. Nous gérons vos fichiers vectoriels (SVG) et vos logos, du tracé de ligne au produit final." },
        { num: "03", title: "Le moment", text: "Tournois sportifs, galas corporatifs, reconnaissances municipales. Un service clé en main, à distance, avec une réactivité maximale — même en dehors des heures d'ouverture." },
      ],
      features: [
        { title: "Gravure laser", text: "Précision au dixième de millimètre sur métal, verre et bois." },
        { title: "Impression couleur", text: "Logos et visuels en quadrichromie, fidèles à vos couleurs." },
        { title: "Validation atelier", text: "Chaque inscription est vérifiée par notre atelier avant la production." },
      ],
    },
    catalogue: {
      kicker: "La Boutique", title_1: "Choisir sa", title_2: "récompense",
      sub: "Chaque pièce est personnalisable : grandeur, quantité dégressive, gravure laser ou impression couleur.",
      loading: "Chargement de la collection…", from: "dès", all: "Tous",
      empty_category: "Aucun produit dans cette catégorie pour l'instant.",
      search_placeholder: "Rechercher un trophée, une médaille, un code…",
      grid_all: "Toutes les catégories", grid_count: "{n} produits",
      grid_more: "Afficher plus de produits ({n} restants)", grid_empty: "Aucun produit ne correspond à votre recherche.",
      filter_color: "Toutes les couleurs", filter_size: "Toutes les grandeurs", filter_catalogue: "Tous les catalogues", filter_sport: "Tous les sports", filter_subcat: "Toutes les sous-catégories",
      sort_price_asc: "Prix : du plus bas au plus haut", sort_price_desc: "Prix : du plus haut au plus bas", sort_name: "Nom (A à Z)",
      grid_from: "Dès {price}",
      show_more: "Afficher plus de produits", results: "produits",
      page_of: "Page {n} sur {total}", goto: "Aller", page_label: "Page",
      page_not_found: "Aucune page {n} dans ce catalogue",
      zoom_in: "Zoom avant", zoom_out: "Zoom arrière", zoom_reset: "Taille réelle",
      click_hint: "Cliquez un produit pour ouvrir sa fiche rapide : grandeur, quantité, personnalisation (texte et logo), puis ajout au panier.",
      view_full: "Voir la fiche complète", prev_page: "Page précédente", next_page: "Page suivante",
      matches: "{n} résultat(s) — cliquez pour aller à la page",
      howto_title: "Comment acheter",
      howto_steps: [
        "Parcourez les produits ou cherchez par nom, code ou catégorie.",
        "Cliquez un produit pour ouvrir sa fiche rapide (ou sa fiche complète).",
        "Choisissez la grandeur et la quantité — les rabais de quantité s'appliquent automatiquement.",
        "Ajoutez votre personnalisation : texte gravé ou imprimé, et votre logo si désiré.",
        "Au panier, envoyez votre demande de soumission préremplie — vous payez en ligne en toute sécurité après l'avoir acceptée.",
      ],
      howto_delays: "Délais de fabrication : minimum 5 jours ouvrables après l'acceptation et le paiement de la soumission. Besoin plus rapide ? Contactez-nous — production express disponible.",
      quote_title: "Soumission rapide",
      quote_text: "Projet spécial, grosse quantité ou date limite serrée ? Écrivez-nous : réponse rapide, même en dehors des heures d'ouverture.",
      quote_messenger: "Messenger", quote_sms: "Texto (SMS)",
      cats: { tous: "Tous", coupes: "Coupes", trophees: "Trophées", medailles: "Médailles", plaques: "Plaques",
        verre: "Verre et cristal", acrylique: "Acrylique", cadeaux: "Cadeaux", hockey: "Hockey",
        resines: "Résines", multisport: "Multisport" },
    },
    category: {
      kicker: "La Boutique",
      not_found: "Catégorie introuvable",
      seo_desc: "Parcourez nos {name} personnalisables : {n} modèles, gravure ou impression, prix dégressifs par quantité, meilleur prix garanti au Canada.",
      intro: "{n} modèles personnalisables avec votre logo ou texte. Prix dégressifs par quantité, fabrication en 5 jours ouvrables minimum, meilleur prix garanti au Canada.",
    },
    product: {
      back: "Retour au catalogue", loading: "Chargement…", not_found: "Produit introuvable.",
      admin_preview: "Aperçu administrateur — ce produit est désactivé : invisible pour les clients, visible ici pour vous seulement.",
      size_title: "Grandeur",
      color_title: "Couleur", finish_title: "Fini", qty_title: "Quantité", tier_applied: "Rabais −{pct} % appliqué",
      image_pending: "Image à venir", load_error: "Produit introuvable ou indisponible.",
      zoom_image: "Agrandir la photo", zoom_in: "Zoom avant", zoom_out: "Zoom arrière",
      zoom_reset: "Taille réelle", zoom_close: "Fermer",
      tier_applied_price: "Palier {min}+ : {price} / unité",
      insc_title: "Inscription",
      gravure: "Gravure laser", gravure_hint: "Texte incisé au laser, finition métallique.",
      impression: "Impression couleur", impression_hint: "Texte et logo en quadrichromie.",
      arriere: "Inscription arrière", arriere_hint: "Texte gravé ou imprimé au dos du produit.",
      aucune: "Sans inscription", aucune_hint: "Le trophée tel quel.",
      per_unit: "+ {price} / unité", unit_suffix: "unité", stock_left: "{n} en stock",
      fee_tbd: "À déterminer", matrice_fee: "Frais de matrice : à déterminer",
      tier_grid_title: "Prix dégressifs par quantité", tier_grid_qty: "Quantité", tier_grid_unit: "Prix unitaire",
      tier_grid_discount: "Rabais", tier_grid_base: "Prix régulier", tier_grid_fee_note: "Frais d'inscription en sus, si choisie.",
      bulk_note: "Besoin d'une plus grande quantité ?", bulk_note_link: "Communiquez avec nous pour un prix sur mesure.",
      stock_capped: "Quantité ajustée au stock disponible ({n})",
      min_qty: "Minimum {n} unités",
      ready_by: "Commandé aujourd'hui : prêt au plus tard le {date} (minimum 5 jours ouvrables de fabrication).",
      setup_fee_note: "Frais d'écran : {s} à la première commande de cet article, puis {r} aux commandes suivantes — facturés une seule fois par commande (jamais par unité).",
      quote_title: "Grande quantité ?", quote_note: "Au-delà de {n} unités, obtenez un prix sur mesure auprès de notre équipe.",
      quote_cta: "Demander un estimé",
      tier_grid_quote: "Demande de soumission",
      quote_popup_title: "Demande de soumission",
      quote_popup_qty: "Quantité visée",
      atelier_note_title: "Note pour l'atelier (optionnel)",
      atelier_note_placeholder: "Instructions spéciales : position du logo, couleurs, contraintes…",
      ai_kicker: "Idées de gravure par IA", ai_placeholder: "Décrivez l'occasion (ex. : tournoi de hockey, gala annuel…)",
      ai_button: "Suggérer", ai_note: "Cliquez une suggestion pour l'utiliser comme texte de gravure.",
      text_placeholder: "Ex. :\nChampions 2026\nTournoi Les Rapides",
      text_lines_hint: "Une ligne de texte par ligne — l'atelier gravera exactement ces lignes (Ligne 1, Ligne 2…).",
      text_lines_max: "Maximum {n} lignes",
      color_fiches_title: "Chaque couleur a sa fiche détaillée",
      preview_note: "Aperçu indicatif — le rendu final est validé par notre atelier avant production.",
      preview_placeholder: "Votre inscription ici",
      logo_title: "Votre logo (optionnel)",
      logo_cta: "Téléverser un logo", logo_uploading: "Téléversement…",
      logo_formats: "PNG, JPG, SVG, PDF ou WebP — 5 Mo max",
      logo_remove: "Retirer le logo", logo_uploaded: "Logo ajouté",
      unit_price: "Prix unitaire", total: "Total ({qty} u.)",
      add_to_cart: "Ajouter au panier", added_toast: "{name} ajouté au panier",
    },
    cart: {
      kicker: "Votre sélection", title: "Panier", empty: "Votre panier est vide.",
      browse: "Parcourir le catalogue", summary: "Résumé", items: "Articles",
      delivery: "Livraison", delivery_note: "Confirmée à la commande",
      subtotal: "Sous-total", checkout: "Demander ma soumission",
      account_required: "Un compte est requis pour commander.",
      gravure: "Gravure laser", impression: "Impression couleur", aucune: "Sans inscription",
      logo: "Logo : {name}",
      atelier_note: "Note atelier",
      color: "Couleur",
      complete_title: "Complétez votre commande",
    },
    freeship: {
      remaining: "Plus que {amount} pour la livraison gratuite",
      unlocked: "Livraison gratuite débloquée !",
      hand_hint: "Livraison en main propre offerte dans un rayon de {km} km de Léry",
    },
    shared_cart: {
      kicker: "Panier partagé",
      title: "Un panier prêt à commander",
      intro: "Quelqu'un vous a préparé cette sélection. Vérifiez-la, ajoutez-la à votre panier et commandez — vous pourrez encore tout modifier.",
      subtotal: "Sous-total (avant taxes et livraison)",
      note: "Les prix sont recalculés au moment de la commande selon les prix en vigueur.",
      add_all: "Tout ajouter à mon panier",
      added: "Articles ajoutés à votre panier !",
      not_found: "Ce panier partagé est introuvable ou expiré.",
      go_shop: "Voir la boutique",
      share_btn: "Partager ce panier",
      share_ready: "Lien du panier prêt — partagez-le :",
      with_inscription: "Avec inscription",
    },
    occasions: {
      kicker: "Par occasion",
      title: "Des récompenses pour chaque événement",
      intro: "Tournoi, gala ou fin d'année : trouvez la récompense parfaite pour votre occasion, gravée à votre image.",
      count: "{n} produits",
      view: "Voir les produits",
      back: "Toutes les occasions",
      empty: "Aucun produit pour cette occasion pour le moment.",
    },
    villes: {
      kicker: "Par ville",
      title: "Trophées et médailles près de chez vous",
      intro: "Atelier de gravure laser en Montérégie, livraison rapide partout au Canada : trouvez votre ville et découvrez nos trophées, médailles et plaques personnalisés.",
      view: "Voir la page",
      back: "Toutes les villes",
      cta_forfaits: "Voir les forfaits tournoi",
      cta_contact: "Demander une soumission",
    },
    promo: {
      placeholder: "Code rabais (ex. WELCOME10)", apply: "Appliquer",
      applied: "Code {code} appliqué", invalid: "Code invalide ou expiré",
      auto: "Rabais de bienvenue {code} appliqué automatiquement — merci d'être abonné à l'info-lettre !",
      auto_short: "Rabais de bienvenue appliqué automatiquement (abonné info-lettre)",
      remove: "Retirer le code", discount: "Rabais",
      scope_inscription: "sur les inscriptions", scope_products: "sur les produits", scope_order: "sur la commande",
      banner: "{code} : {amount} de rabais {scope}",
      banner_welcome: "Inscrivez-vous à notre info-lettre (infos et spéciaux) et recevez un rabais de bienvenue par courriel — valable sur votre première commande.",
      banner_hint: "Entrez le code au panier ou à la caisse",
      banner_cta: "S'abonner à l'info-lettre",
      banner_cond_inscription: "Offert à l'inscription",
      banner_cond_distribution: "Offert à l'abonnement à notre liste de distribution",
      banner_cond_referencement: "Offert aux clients référés",
      popup_kicker: "Offre du jour",
      popup_title: "Bienvenue chez Mr Trophée",
      popup_sub: "Deux façons d'économiser 10 % dès aujourd'hui :",
      popup_welcome_title: "−10 % de rabais de bienvenue",
      popup_welcome_desc: "Inscrivez-vous à notre info-lettre (infos et spéciaux) : confirmez votre inscription en cliquant le lien dans notre courriel, et votre rabais de bienvenue vous sera envoyé par courriel — valable sur votre première commande.",
      popup_friend_title: "−10 % avec REF10",
      popup_friend_desc: "Référez un ami : votre filleul profite d'un rabais de bienvenue et vous recevez votre code personnel.",
      popup_cta: "Magasiner",
      popup_cta_subscribe: "S'abonner à la lettre d'information",
      popup_later: "Plus tard",
      popup_newsletter_link: "S'abonner à la lettre d'information (infos et spéciaux)",
      popup_copied: "Code {code} copié !",
      newsletter: {
        placeholder: "Votre courriel",
        cta: "S'abonner",
        success_title: "Vérifiez votre boîte courriel !",
        success_body: "Cliquez le lien de confirmation dans notre courriel — votre code de bienvenue vous sera envoyé juste après.",
        code_title: "Vous êtes déjà abonné !",
        code_body: "Voici votre code de bienvenue — il vient aussi de vous être renvoyé par courriel.",
        invalid: "Entrez un courriel valide",
        hint: "Nouveautés et spéciaux, sans pourriel. Désabonnement en tout temps.",
        dialog_title: "Lettre d'information",
      },
    },
    checkout: {
      kicker: "Dernière étape", title: "Votre soumission",
      gate_title: "Créez votre compte pour compléter votre demande",
      gate_text: "Pour faire un achat chez Mr Trophée, l'inscription est obligatoire — c'est gratuit et ça prend 30 secondes. Votre panier est conservé : vous le retrouverez tel quel après votre inscription.",
      gate_register: "Créer mon compte", gate_login: "J'ai déjà un compte — me connecter",
      last_name: "Nom", first_name: "Prénom", company: "Entreprise ou club",
      address1: "Adresse", address2: "Adresse — ligne 2 (app., bureau…)",
      city: "Ville", postal_code: "Code postal", phone: "Téléphone", email: "Courriel",
      delivery_label: "Date de livraison souhaitée",
      delivery_note: "Prévoir un minimum de 5 jours ouvrables pour la production.",
      delivery_method: "Mode de réception", delivery_ship: "Livraison", delivery_ship_desc: "Expédition à votre adresse par transporteur",
      delivery_pickup: "Ramasser à l'atelier", delivery_pickup_desc: "1314 ch. du Lac-Saint-Louis, Léry QC — gratuit",
      delivery_hand: "Livraison en main propre", delivery_hand_desc: "Par Mr Trophée en personne, dans un rayon de {km} km",
      hand_note: "Nous vous contacterons pour convenir du moment de la livraison à votre porte.",
      hand_tier_under: "Moins de {km} km", hand_tier_range: "De {from} à {to} km",
      beyond_note: "Au-delà de 50 km : expédition par transporteur — livraison jusqu'à 5 jours suivant l'approbation de l'épreuve et du paiement.",
      pickup_note: "Nous vous contacterons quand votre commande sera prête au ramassage.",
      notes_label: "Notes pour l'atelier",
      notes_placeholder: "Logo à intégrer, précisions sur la gravure…",
      summary: "Récapitulatif", total: "Estimation",
      estimate_note: "Estimation des produits avant personnalisation — gravure, impression couleur et frais de matrice : à déterminer. Le prix final est confirmé dans votre soumission, payable en ligne ensuite.",
      pay: "Envoyer ma demande de soumission", paying: "Envoi en cours…",
      sent_title: "Demande de soumission envoyée !",
      sent_text: "Votre panier et vos coordonnées sont entre les mains de l'atelier. Vous recevrez votre soumission détaillée par courriel — vous pourrez l'accepter et la payer en ligne en toute sécurité.",
      method_invalid: "Complétez tous les champs obligatoires avant d'envoyer.",
      saved_addresses: "Mes adresses enregistrées", shortcut_active: "Raccourci appliqué",
      province: "Province", subtotal: "Sous-total (produits)", shipping: "Livraison standard", shipping_free: "Gratuite",
      tax_tps: "TPS (5 %)", tax_tvq: "TVQ (9,975 %)", tax_tvh: "TVH / HST",
      shop_closed: "La boutique en ligne est temporairement fermée. Revenez bientôt ou communiquez avec nous.",
      provinces: {
        QC: "Québec", ON: "Ontario", NB: "Nouveau-Brunswick", NS: "Nouvelle-Écosse",
        PE: "Île-du-Prince-Édouard", NL: "Terre-Neuve-et-Labrador", MB: "Manitoba", SK: "Saskatchewan",
        AB: "Alberta", BC: "Colombie-Britannique", NT: "Territoires du Nord-Ouest", NU: "Nunavut", YT: "Yukon",
      },
      secure_note: "Aucun paiement maintenant — vous payez en ligne après avoir accepté la soumission.",
      returns_note: "Aucun retour sur les articles gravés ou imprimés (fabriqués sur mesure).",
    },
    payment: {
      confirming: "Confirmation du paiement…",
      confirming_sub: "Nous vérifions votre transaction auprès de Stripe.",
      confirmed_title: "Merci, champion.",
      confirmed: "Votre paiement est confirmé. Notre atelier commence la production.",
      order_number: "Commande {num}",
      track: "Suivre ma commande", catalogue: "Catalogue",
      failed_title: "Paiement non confirmé",
      failed: "Le paiement n'a pas abouti. Aucun montant n'a été prélevé.",
      timeout: "La confirmation prend plus de temps que prévu. Vérifiez votre compte dans quelques minutes.",
      back_to_cart: "Retour au panier",
      cancel_title: "Paiement annulé",
      cancel_sub: "Aucun montant n'a été prélevé. Votre panier est toujours là.",
    },
    login: {
      kicker: "Espace membre",
      title: "Connexion", sub: "Accédez à vos commandes et à votre espace.",
      email: "Courriel", password: "Mot de passe", submit: "Se connecter",
      no_account: "Pas encore de compte ?", create: "Créer un compte",
    },
    register: {
      title: "Créer un compte", sub: "Requis pour commander et suivre vos productions.",
      name: "Nom complet", email: "Courriel", password: "Mot de passe", submit: "Créer mon compte",
      first_name: "Prénom", last_name: "Nom", phone: "Numéro de téléphone",
      address: "Adresse complète", city: "Ville", province: "Province", postal: "Code postal",
      newsletter: "Je m'inscris à l'info-lettre pour recevoir nos promotions.",
      confirm_password: "Confirmer le mot de passe", password_mismatch: "Les mots de passe ne correspondent pas.",
      have_account: "Déjà membre ?", login: "Se connecter",
    },
    account: {
      hello: "Bonjour, {name}", title: "Mes commandes",
      none: "Aucune commande pour l'instant.", browse: "Découvrir La Boutique",
      delivery: "Livraison souhaitée", total: "Total", loading: "Chargement…",
    },
    auth: { google: "Continuer avec Google", or: "ou" },
    verify: {
      banner: "Confirmez votre courriel pour activer votre compte et pouvoir commander (vérifiez vos indésirables).",
      resend: "Renvoyer le courriel",
      resent: "Courriel de confirmation renvoyé — vérifiez votre boîte de réception.",
      resend_error: "Envoi impossible pour le moment, réessayez plus tard.",
    },
    confirm: {
      checking: "Confirmation de votre courriel…",
      success_title: "Courriel confirmé !",
      success_text: "Votre compte est maintenant actif. Vous pouvez parcourir les catalogues et commander.",
      error_title: "Lien invalide",
      error_text: "Ce lien de confirmation est invalide ou a déjà été utilisé. Connectez-vous à votre compte pour en recevoir un nouveau.",
      cta_catalogue: "Découvrir la boutique", cta_login: "Me connecter",
    },
    referral: {
      title: "Référez un ami, recevez −10 %",
      text: "Partagez votre lien : votre filleul profite d'un rabais de bienvenue sur sa première commande, et vous recevez un code personnel −10 % dès que sa première commande est payée.",
      copy: "Copier le lien", copied: "Lien copié !",
      clicks: "Clics sur votre lien", referred: "Filleuls inscrits",
      rewards: "Vos codes de remerciement", no_rewards: "Aucune récompense pour l'instant — partagez votre lien !",
      used: "utilisé", valid_until: "valide jusqu'au",
      note: "Vous avez été référé : un rabais de bienvenue peut s'appliquer à votre première commande.",
      page_kicker: "Programme de parrainage",
      how_title: "Comment ça fonctionne",
      how_1: "Partagez votre lien personnel avec un club, une entreprise ou un ami.",
      how_2: "Il crée son compte via votre lien et applique le code REF10 à sa première commande.",
      how_3: "Quand sa commande est payée, vous recevez votre code −10 % personnel par courriel.",
      your_code: "Votre code personnel",
      your_link: "Votre lien de parrainage",
      filleul_code: "Code à donner à votre filleul",
      cta_login: "Connectez-vous pour obtenir votre lien personnel",
      cta_login_btn: "Connexion ou création de compte",
      page_note: "Un usage par code, applicable sur les produits seulement (jamais sur la gravure ni l'impression). Valide 1 an.",
    },
    badge: {
      page_kicker: "Programme partenaire",
      title: "Affichez fièrement vos trophées",
      text: "Votre club, votre ligue ou votre entreprise a reçu des récompenses de notre atelier ? Ajoutez le badge « Trophées par Mr Trophée » à votre site web : copiez le code, collez-le dans votre page — c'est tout.",
      alt: "Trophées et médailles personnalisés — Mr Trophée",
      how_title: "Comment ça fonctionne",
      how_1: "Choisissez le badge qui s'agence le mieux à votre site (fond foncé ou clair).",
      how_2: "Copiez le code HTML correspondant avec le bouton « Copier le code ».",
      how_3: "Collez-le dans le pied de page ou la page partenaires de votre site — le badge y apparaît aussitôt.",
      dark_title: "Badge foncé — pour les sites clairs",
      light_title: "Badge clair — pour les sites foncés",
      text_title: "Lien texte — la version la plus simple",
      text_link_preview: "Trophées et médailles par Mr Trophée — atelier de Léry, Québec",
      copy: "Copier le code", copied: "Code copié !",
      why_title: "Pourquoi l'afficher ?",
      why_text: "Vos membres et visiteurs sauront où commander leurs propres récompenses — et chaque badge affiché fait rayonner l'atelier dans la région. Merci de votre appui !",
      cta: "Une question ? Écrivez-nous",
      note: "Aucune inscription requise : le badge est offert à tous nos clients et partenaires.",
    },
    pwd: {
      forgot_link: "Mot de passe oublié ?",
      forgot_title: "Mot de passe oublié",
      forgot_sub: "Entrez votre courriel : si un compte existe, un lien de réinitialisation vous sera envoyé (valide 1 heure).",
      forgot_send: "Envoyer le lien",
      forgot_done: "Si un compte existe avec ce courriel, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte de réception (et les indésirables).",
      back_login: "Retour à la connexion",
      reset_title: "Nouveau mot de passe",
      reset_sub: "Choisissez votre nouveau mot de passe.",
      reset_new: "Nouveau mot de passe",
      reset_confirm: "Confirmez le mot de passe",
      reset_mismatch: "Les mots de passe ne correspondent pas",
      reset_submit: "Enregistrer le mot de passe",
      reset_done: "Mot de passe changé ! Vous êtes connecté.",
      remember: "Garder ma session active (90 jours)",
    },
    status: {
      en_attente_paiement: "En attente de paiement", payee: "Payée", en_production: "En production",
      expediee: "Expédiée", livree: "Livrée", annulee: "Annulée", remboursee: "Remboursée",
    },
    shipstatus: {
      created: "Étiquette créée", ready: "Prête à expédier", in_transit: "En transit", out_for_delivery: "En cours de livraison",
      delivered: "Livrée", exception: "Problème de livraison", returned: "Retournée", cancelled: "Annulée",
    },
    maintenance: {
      message: "Bienvenue ! Notre boutique en ligne est temporairement fermée pour maintenance.",
      cta: "Consultez nos catalogues en ligne →",
      title: "En maintenance",
      subtitle: "Notre boutique en ligne est temporairement fermée. Nos catalogues restent accessibles — nous revenons très vite !",
      redirect: "Redirection vers les catalogues dans",
      cta_now: "Voir les catalogues maintenant",
    },
    account_extra: {
      tracking: "Numéro de suivi",
      profile_title: "Mes coordonnées", first_name: "Prénom", last_name: "Nom",
      phone: "Téléphone", email: "Courriel", save: "Enregistrer", profile_saved: "Coordonnées enregistrées",
      addresses_title: "Mes adresses", add_address: "Ajouter une adresse",
      address_label: "Nom de l'adresse (ex. : Maison, Bureau)",
      no_addresses: "Aucune adresse enregistrée — elles s'ajoutent automatiquement à chaque commande.",
      address_added: "Adresse enregistrée", address_deleted: "Adresse supprimée",
      set_default: "Adresse par défaut", default_badge: "Par défaut",
      default_saved: "Adresse par défaut mise à jour",
    },
    about: {
      kicker: "Notre histoire",
      title_1: "L'atelier derrière", title_2: "chaque victoire",
      p1: "Chez Mr Trophée, nous transformons vos moments de victoire et de reconnaissance en souvenirs durables. Spécialistes de la gravure de haute précision en Montérégie, nous concevons des trophées, médailles et plaques personnalisés pour les entreprises, les municipalités et les organisations sportives du Québec.",
      p2: "Service bilingue et clé en main : de la conception graphique (logos, tracés de lignes, fichiers vectoriels SVG) au produit final, avec transfert laser et impression spécialisée. Les projets à distance sont simplifiés, avec une réactivité maximale — nous répondons même en dehors des heures d'ouverture.",
      values: [
        { title: "Meilleur prix garanti", text: "Des récompenses d'exception au meilleur prix garanti au Canada. Trouvez moins cher ailleurs : nous nous alignons." },
        { title: "Précision d'atelier", text: "Gravure laser haute précision sur métal, verre et bois, et impression couleur fidèle à vos couleurs." },
        { title: "Clé en main", text: "Conception graphique, fichiers vectoriels, production et livraison : un seul interlocuteur pour tout." },
      ],
      services_kicker: "Nos services",
      services_title_1: "Tout sous", services_title_2: "un même toit",
      services_sub: "21 services d'atelier, de la conception graphique à la livraison — au meilleur prix garanti au Canada.",
      services: [
        "Gravure au laser personnalisée sur presque tous les matériaux",
        "Gravure assistée par CNC",
        "Sérigraphie assistée par ordinateur — laiton, aluminium, plastique, acrylique, bois, stylos, verre",
        "Gravure spécialisée à l'intérieur de bagues, bijoux et montres",
        "Insertion de photo dans une montre",
        "Trophées pour toutes les occasions",
        "Signalisation et identification de portes",
        "Plaquettes d'identité (name tags)",
        "Plaques Lamicoïdes",
        "Logos et infographie",
        "Affichage et lettrage",
        "Sérigraphie et impression spécialisée",
        "Affichage grand format — bannières, pancartes, affiches coroplast",
        "Médailles génériques",
        "Médailles sur mesure fabriquées au Québec",
        "Trophées de gala",
        "Trophées en série — production rapide (200 en 1 semaine)",
        "Trophées perpétuels",
        "Gravure sur verre",
        "Gravure sur cuir et bouteilles",
        "Coupes de qualité",
      ],
      cta: "Découvrir La Boutique",
    },
    faq: {
      kicker: "Questions fréquentes", title_1: "Tout savoir avant", title_2: "de commander",
      items: [
        { q: "Quels sont les délais de production ?", a: "Comptez un minimum de 5 jours ouvrables après la confirmation du paiement, selon la quantité et la personnalisation. Vous choisissez votre date de livraison souhaitée à la commande et nous la confirmons par courriel." },
        { q: "Quels fichiers acceptez-vous pour les logos ?", a: "Idéalement des fichiers vectoriels (SVG, PDF) pour une gravure parfaite, mais nous acceptons aussi PNG, JPG et WebP. Notre équipe prépare et valide chaque fichier avant production — sans frais supplémentaires." },
        { q: "Comment fonctionnent les rabais de quantité ?", a: "Les paliers maison s'appliquent automatiquement : −5 % dès 6 unités, −8 % dès 12 et −10 % dès 24 (certains produits ont leurs propres prix par quantité du fournisseur). Grande quantité ? Communiquez avec nous pour un prix sur mesure." },
        { q: "Gravure laser ou impression couleur : que choisir ?", a: "La gravure laser incise le matériau pour un rendu métallique permanent et haut de gamme. L'impression couleur reproduit logos et visuels en quadrichromie. Notre atelier valide le rendu avant la production." },
        { q: "Livrez-vous partout au Canada ?", a: "Oui. Basés en Montérégie, nous livrons partout au Canada. Les frais et le suivi sont confirmés lors du traitement de votre commande." },
        { q: "Le meilleur prix garanti, comment ça marche ?", a: "Si vous trouvez un produit équivalent moins cher ailleurs au Canada, écrivez-nous avec la preuve : nous nous alignons sur le prix." },
      ],
      cta: "Une autre question ?", cta_btn: "Contactez-nous",
    },
    forfaits: {
      kicker: "Clé en main", title_1: "Forfaits", title_2: "tournoi",
      intro: "Médailles, trophées et gravure — un prix clair par équipe, calculé en direct de notre catalogue. Aucun calcul à faire : choisissez votre forfait, on s'occupe du reste.",
      players_label: "Nombre de joueurs ou d'équipes",
      players_unit: "joueurs",
      per_player: "par joueur",
      min_players: "min. {n} joueurs",
      total: "Total estimé",
      includes: "Comprend",
      volume_note: "Les prix peuvent varier selon la quantité.",
      popular: "Le plus populaire",
      cta: "Demander ma soumission",
      cta_sub: "Réponse en moins de 24 h ouvrables — sans obligation",
      form_title: "Votre soumission en 30 secondes",
      form_name: "Votre nom", form_phone: "Téléphone", form_org: "Organisation / club", form_city: "Ville",
      form_sport: "Sport", form_date: "Date du tournoi (approximative)",
      form_send: "Recevoir ma soumission", form_sending: "Envoi en cours…",
      form_done_title: "Demande envoyée !",
      form_done: "Nous vous rappelons rapidement avec votre prix confirmé. Merci de votre confiance.",
      chosen: "Forfait choisi",
      gate_title: "Créez votre compte gratuit",
      gate_text: "La soumission est réservée à nos clients inscrits : elle sera liée à votre compte, avec le numéro de chaque produit et son catalogue — suivi simple et sans erreur.",
      gate_login: "Je me connecte", gate_register: "Créer mon compte (1 minute)",
      account_line: "Votre compte",
      seo_title: "Forfaits Tournoi clé en main — médailles, trophées et gravure | Mr Trophée",
      seo_desc: "Forfaits tournoi sur mesure : médailles gravées pour chaque joueur, trophées pour les gagnants, prix clair par équipe. Soumission en 24 h partout au Québec.",
      p1_name: "Bronze", p1_tag: "Chaque joueur repart avec sa médaille",
      p2_name: "Argent", p2_tag: "Médailles + le trophée des champions",
      p3_name: "Or", p3_tag: "Un trophée pour chaque joueur",
      p1_item_medal: "Médaille 2 po — ruban 7/8 po, insertion avant avec votre logo, inscription arrière personnalisée",
      p1_item_medal_pl: "Médailles 2 po — ruban 7/8 po, insertion avant avec votre logo, inscription arrière personnalisée",
      p2_item_medal: "Médaille jusqu'à 2,5 po — ruban 7/8 po, insertion avant avec votre logo, inscription arrière personnalisée",
      p2_item_medal_pl: "Médailles jusqu'à 2,5 po — ruban 7/8 po, insertion avant avec votre logo, inscription arrière personnalisée",
      p3_item_medal: "Médaille jusqu'à 3 po — ruban 7/8 po, insertion avant avec votre logo, inscription arrière personnalisée",
      p3_item_trophy_each: "Trophée par joueur — modèle au choix",
      p3_item_trophy_each_pl: "Trophées par joueur — modèle au choix",
      item_trophy_choice: "1 trophée d'équipe au choix",
      item_medals: "Médailles gravées (ruban aux couleurs de votre club)",
      item_trophy_1: "1 trophée gravé pour l'équipe championne",
      item_trophy_3: "3 trophées gravés (1re, 2e et 3e place)",
      item_plaque: "1 plaque commémorative gravée pour l'organisation",
    },
    livraison: {
      kicker: "Service local",
      title: "Livraison* en main propre de vos produits, jusqu'à 50 km de Léry",
      meta: "Livraison en main propre de trophées, médailles et plaques gravés jusqu'à {radius} km de notre atelier de Léry (Montérégie) : dès {fee}, sans transporteur. Au-delà : expédition par transporteur, jusqu'à 5 jours suivant l'approbation de l'épreuve et du paiement.",
      intro: "Vos trophées, médailles et plaques gravés vous sont remis en personne par notre équipe, partout dans un rayon de {radius} km de notre atelier de Léry — Montréal, Rive-Sud, Vaudreuil-Soulanges et la Vallée-du-Richelieu inclus.",
      beyond: "Plus loin que 50 km ? Nous livrons rapidement partout au Canada à petit prix — meilleur prix garanti.",
      steps: [
        { h: "Vous commandez en ligne", p: "Choisissez vos trophées, médailles ou plaques — prix dégressifs dès 6 unités." },
        { h: "Nous gravons à Léry", p: "Chaque pièce est personnalisée dans notre atelier de Léry, en Montérégie, avec le meilleur prix garanti." },
        { h: "Livraison en main propre ({radius} km)", p: "Notre équipe vous remet votre commande en personne — frais selon la distance, sans compagnie de transport ni colis perdu." },
      ],
      zone_title: "Zone de livraison en main propre",
      zone_text: "Partout dans un rayon de {radius} km : Montréal, Laval, Longueuil, Brossard, Châteauguay, Saint-Jérôme, Terrebonne, Repentigny et bien plus. Trouvez la vôtre :",
      cta_villes: "Trouvez votre ville",
      cta_contact: "Demander une soumission",
      fee_note: "* Frais de livraison en sus, selon la distance :",
      tier_under: "Moins de {km} km",
      tier_range: "{from} à {to} km",
      price_note: "Calculés automatiquement à la caisse selon votre code postal. Gratuit si vous préférez le ramassage à l'atelier de Léry. Au-delà de 50 km : expédition par transporteur — livraison jusqu'à 5 jours suivant l'approbation de l'épreuve et du paiement.",
      seo_keywords: "livraison en main propre trophées, livraison trophées Montérégie, livraison médailles Léry, trophées livrés en personne, livraison locale trophées 50 km",
      service_type: "Livraison en main propre de trophées",
    },
    productReviews: {
      title: "Avis clients", verified: "Achat vérifié",
      based_on: "basé sur", reviews_word: "avis",
      none: "Aucun avis pour le moment — soyez le premier client à partager votre expérience !",
      write: "Donner mon avis", your_rating: "Votre note", your_text: "Votre avis (minimum 10 caractères)",
      send: "Publier mon avis", sending: "Envoi…",
      moderation_note: "Votre avis sera visible après approbation par notre équipe.",
      thanks: "Merci ! Votre avis sera affiché après modération.",
      already: "Merci ! Vous avez déjà donné votre avis sur ce produit.",
      pending: "Votre avis est en attente de modération — merci !",
      login_first: "Connectez-vous pour donner votre avis",
      only_buyers: "Seuls les clients ayant commandé ce produit peuvent laisser un avis.",
    },
    forfaitBanner: {
      title: "Saison des tournois !",
      text: "Médailles + trophées + gravure : un forfait clé en main, un prix clair par équipe.",
      cta: "Voir les forfaits", close: "Fermer le bandeau",
    },
    mySoumissions: {
      title: "Mes soumissions de forfaits",
      none: "Aucune demande de soumission pour le moment.",
      players: "joueurs", pending: "En attente", done: "Traitée",
      sent_on: "envoyée le", estimated: "Total estimé",
      new: "Nouvelle soumission",
    },
    myQuotes: {
      title: "Mes soumissions de trophées",
      items: "article(s)", sent_on: "envoyée le",
      proof_accepted: "Épreuve acceptée le", proof_warning: "avertissement accepté",
      portal: "Ouvrir ma soumission",
      st_attente: "En attente", st_accepte: "Acceptée", st_paye: "Payée",
      st_commande: "Commandée", st_expedie: "Expédiée", st_livre: "Livrée",
    },
    magicReview: {
      kicker: "Votre avis en 60 secondes",
      sub: "Lien personnel lié à votre commande",
      placeholder: "Comment s'est passée votre commande ? Qualité, gravure, délais…",
      send: "Publier mon avis",
      thanks_title: "Merci beaucoup !",
      thanks_text: "Votre avis sera affiché sur la fiche produit après validation par notre équipe.",
      back_shop: "Retour à la boutique",
      home: "Retour à l'accueil",
      seo_title: "Laisser mon avis | Mr Trophée",
    },
    contact: {
      kicker: "Contact", title_1: "Parlons de", title_2: "votre projet",
      sub: "Une question, un devis sur mesure, une preuve de prix ? Écrivez-nous — nous répondons même en dehors des heures d'ouverture.",
      first_name: "Prénom", last_name: "Nom de famille", email: "Courriel", message: "Votre message",
      message_placeholder: "Décrivez votre projet : quantité, délais, type de récompense…",
      send: "Envoyer le message", sending: "Envoi en cours…",
      sent: "Message envoyé — nous vous répondrons rapidement.",
      references_label: "Références du catalogue (optionnel)",
      references_placeholder: "Ex. : PDU #T-245, Marco nº 3187, quantités…",
      info_title: "Nous joindre",
      region: "1314 ch. du Lac-Saint-Louis, Léry (Québec) J6N 1B1",
      phone: "+1 514-565-6665",
      texto: "Texto",
      hours: "Réponse même en dehors des heures d'ouverture",
      social: "Aussi joignable sur Facebook (Messenger)",
      messenger: "Venez discuter avec nous sur Messenger",
      call_cta: "Demander un appel",
      rdv_cta: "Prendre rendez-vous",
      call_title: "On vous rappelle",
      call_sub: "Laissez votre numéro — nous vous rappelons rapidement, même en dehors des heures d'ouverture.",
      call_phone: "Votre téléphone",
      call_city: "Ville",
      call_org: "Organisation / club",
      call_city_placeholder: "Ex. : Châteauguay",
      call_postal: "Code postal",
      call_org_placeholder: "Ex. : Association de hockey mineur de…",
      call_time: "Moment souhaité pour le rappel (optionnel)",
      call_time_placeholder: "Ex. : ce soir après 18 h, demain midi…",
      call_date: "Date souhaitée",
      call_from: "De",
      call_to: "À",
      call_subject: "Sujet (optionnel)",
      call_subject_placeholder: "Ex. : trophées pour notre tournoi de hockey…",
      call_send: "Demander un appel",
      call_sent: "Demande envoyée — nous vous rappellerons rapidement.",
      call_back: "Écrire plutôt un message",
    },
    catalogues: {
      kicker: "Catalogues fournisseurs",
      title_1: "Nos catalogues", title_2: "en ligne",
      popup_note: "Ce catalogue s'ouvre sur le site du fournisseur, dans un nouvel onglet.",
      popup_open: "Ouvrir le catalogue chez le fournisseur",
      intro: "Comment commander votre création sur mesure ? Obtenez une estimation rapide et gratuite en seulement 3 étapes faciles :",
      cta: "Obtenir mon estimation gratuite",
      custom_kicker: "Création sur mesure",
      custom_title: "Un modèle vous plaît ? Parlons-en.",
      custom_sub: "Envoyez-nous vos références et quantités par le canal de votre choix — réponse rapide, même en dehors des heures d'ouverture.",
      custom_form: "Formulaire détaillé",
      viewer_back: "Retour aux catalogues",
      viewer_external: "Ouvrir dans le site fournisseur",
      viewer_open: "Ouvrir le catalogue",
      viewer_share: "Partager ce catalogue",
      viewer_blocked_kicker: "Catalogue fournisseur",
      viewer_blocked_text: "Le fournisseur de ce catalogue ne permet pas son affichage intégré ici. Ouvrez-le en plein écran dans un nouvel onglet — votre panier et vos favoris vous attendent sur Mr Trophée.",
      viewer_shop: "Voir les produits dans la boutique",
      viewer_help: "Le catalogue ne s'affiche pas ? Certains fournisseurs bloquent l'affichage intégré — utilisez « Ouvrir le catalogue ».",
      viewer_invalid: "Ce lien de catalogue est invalide.",
      steps: [
        "Parcourez nos catalogues en ligne ci-dessous pour choisir vos modèles.",
        "Notez les références des produits qui vous intéressent ainsi que les quantités désirées.",
        "Envoyez-nous vos détails pour la gravure ou l'impression (ou ajoutez votre logo en format SVG/haute résolution).",
      ],
      groups: [
        {
          title: "Catalogue nº 1 — Trophées, médailles, plaques (PDU)",
          links: [
            /* external: le site fournisseur s'ouvre dans le conteneur plein écran,
               pas dans la visionneuse interne (demande du propriétaire) */
            { label: "Catalogue nº 1.0", url: "https://www.awardsofdistinction.ca/", external: true },
            { label: "Catalogue nº 1.1 (FiveStars)", url: "https://www.fivestarrecognition.ca/" },
            { label: "Catalogue nº 1.2 — Brochures", url: "https://www.awardsofdistinction.ca/awards_brochures.html" },
            { label: "Catalogue nº 1.3 — Nouveautés PDU", url: "https://www.plasticdressup.ca/content/product_spotlight.html" },
            { label: "Catalogue nº 1.4 — Academic", url: "https://www.awardsofdistinction.ca/academic.html" },
            { label: "Catalogue nº 1.5 — Baseball", url: "https://www.awardsofdistinction.ca/baseball.html" },
            { label: "Catalogue nº 1.6 — Basketball", url: "https://www.awardsofdistinction.ca/basketball.html" },
            { label: "Catalogue nº 1.7 — Football", url: "https://www.awardsofdistinction.ca/football.html" },
            { label: "Catalogue nº 1.8 — Fusion", url: "https://www.awardsofdistinction.ca/fusion.html" },
            { label: "Catalogue nº 1.9 — Golf", url: "https://www.awardsofdistinction.ca/golf.html" },
            { label: "Catalogue nº 1.10 — Hockey", url: "https://www.awardsofdistinction.ca/hockey.html" },
            { label: "Catalogue nº 1.11 — Soccer", url: "https://www.awardsofdistinction.ca/soccer.html" },
          ],
        },
        {
          title: "Catalogue nº 2 — Trophées, médailles, récompenses (TR)",
          links: [
            { label: "Catalogue nº 2.0", url: "https://tromartawards.com/nc2023/#p=1" },
          ],
        },
        {
          title: "Catalogue nº 3 — Trophées, médailles, plaques (DTC)",
          links: [
            { label: "Catalogue nº 3.0 (Marco Awards 2025)", url: "https://online.fliphtml5.com/zddpr/Marco-Awards-Group-2025-Big-Book/#p=1" },
            { label: "Catalogue nº 3.1 — Tumblers (été)", url: "https://discounttrophy.ca/wp-content/uploads/2024/01/Flyer-Tumbler-Ete-Summer-3-compresse.pdf" },
            { label: "Catalogue nº 3.2 — Corporatif et cadeaux", url: "https://online.fliphtml5.com/zddpr/bbue/#p=1" },
            { label: "Catalogue nº 3.3 — Trophées et cadeaux", url: "https://discounttrophy.ca/wp-content/uploads/2023/07/award-400x518.jpg" },
            { label: "Catalogue nº 3.4 — Golf", url: "http://golf.awardscat.com/#p=1" },
            { label: "Catalogue nº 3.5 — Hockey", url: "https://discounttrophy.ca/wp-content/uploads/2022/11/HOCKEY-2022.pdf" },
            { label: "Catalogue nº 3.6 — Football", url: "https://discounttrophy.ca/wp-content/uploads/2019/08/FOOTBALL.pdf" },
          ],
        },
        {
          title: "Catalogue nº 4 — Trophées, médailles, plaques (CR)",
          links: [
            { label: "Catalogue nº 4.0", url: "https://caldwellrecognition.com/catalogs/awards_and_recognition/Index.html#p=1" },
            { label: "Catalogue nº 4.1 — Academic", url: "https://www.awardsandrecognition.ca/catalogs/Academic/index.html#p=1" },
            { label: "Catalogue nº 4.2 — Badminton", url: "https://caldwellrecognition.com/catalogs/Badminton/index.html#p=1" },
            { label: "Catalogue nº 4.3 — Ballon-balai", url: "https://caldwellrecognition.com/catalogs/Ballhockey/index.html#p=1" },
            { label: "Catalogue nº 4.4 — Baseball", url: "https://caldwellrecognition.com/catalogs/Baseball/index.html#p=1" },
            { label: "Catalogue nº 4.5 — Basketball", url: "https://caldwellrecognition.com/catalogs/Basketball/index.html#p=1" },
            { label: "Catalogue nº 4.6 — Billard", url: "https://www.awardsandrecognition.ca/catalogs/Billiards/index.html#p=1" },
            { label: "Catalogue nº 4.7 — Quilles", url: "https://caldwellrecognition.com/catalogs/Bowling/index.html#p=1" },
            { label: "Catalogue nº 4.8 — Cheerleading", url: "https://www.awardsandrecognition.ca/catalogs/Cheer/index.html#p=1" },
            { label: "Catalogue nº 4.9 — Échecs", url: "https://www.awardsandrecognition.ca/catalogs/Chess/index.html#p=1" },
            { label: "Catalogue nº 4.10 — Entraîneur", url: "https://www.awardsandrecognition.ca/catalogs/Coach/index.html#p=1" },
            { label: "Catalogue nº 4.11 — Curling", url: "https://www.awardsandrecognition.ca/catalogs/Curling/index.html#p=1" },
            { label: "Catalogue nº 4.12 — Danse", url: "https://www.awardsandrecognition.ca/catalogs/Dance/index.html#p=1" },
            { label: "Catalogue nº 4.13 — Fléchettes", url: "https://www.awardsandrecognition.ca/catalogs/Darts/index.html#p=1" },
            { label: "Catalogue nº 4.14 — Patinage artistique", url: "https://www.awardsandrecognition.ca/catalogs/Figure_Skating/index.html#p=1" },
            { label: "Catalogue nº 4.15 — Football", url: "https://caldwellrecognition.com/catalogs/Football/index.html#p=1" },
            { label: "Catalogue nº 4.16 — Golf", url: "https://caldwellrecognition.com/catalogs/Golf/index.html#p=1" },
            { label: "Catalogue nº 4.17 — Hockey", url: "https://caldwellrecognition.com/catalogs/Hockey/index.html#p=1" },
            { label: "Catalogue nº 4.18 — Équestre", url: "https://www.awardsandrecognition.ca/catalogs/Horses/index.html#p=1" },
            { label: "Catalogue nº 4.19 — Crosse", url: "https://caldwellrecognition.com/catalogs/Lacrosse/index.html#p=1" },
            { label: "Catalogue nº 4.20 — Arts martiaux", url: "https://www.awardsandrecognition.ca/catalogs/MartialArts/index.html#p=1" },
            { label: "Catalogue nº 4.21 — Musique", url: "https://www.awardsandrecognition.ca/catalogs/Music/index.html#p=1" },
            { label: "Catalogue nº 4.22 — Course automobile", url: "https://www.awardsandrecognition.ca/catalogs/Racing/index.html#p=1" },
            { label: "Catalogue nº 4.23 — Soccer", url: "https://caldwellrecognition.com/catalogs/Soccer/index.html#p=1" },
            { label: "Catalogue nº 4.24 — Natation", url: "https://caldwellrecognition.com/catalogs/Swimming/index.html#p=1" },
            { label: "Catalogue nº 4.25 — Tennis", url: "https://caldwellrecognition.com/catalogs/Tennis/index.html#p=1" },
            { label: "Catalogue nº 4.26 — Athlétisme", url: "https://www.awardsandrecognition.ca/catalogs/Track/index.html#p=1" },
            { label: "Catalogue nº 4.27 — Volleyball", url: "https://caldwellrecognition.com/catalogs/Volleyball/index.html#p=1" },
          ],
        },
        {
          title: "Catalogue nº 5 — Produits promotionnels (U)",
          links: [
            { label: "Catalogue nº 5.0 (U)", url: "https://www.urbanointernational.com/" },
          ],
        },
        {
          title: "Vêtements professionnels",
          links: [
            { label: "Nouveautés 2024/2025", url: "http://s3.amazonaws.com/giant-fashions/file_properties/408/20240409132536867/Giant_Fashions_Stock_Catalog_2024.pdf" },
            { label: "Green Thinking", url: "http://s3.amazonaws.com/giant-fashions/file_properties/408/20240409132327608/Ecorite_2024_Showcase.pdf" },
            { label: "Canada Sportswear", url: "http://s3.amazonaws.com/giant-fashions/file_properties/408/20240410054624988/Canada_Sportswear_2024_Stock_Catalog_2.pdf" },
          ],
        },
      ],
    },
    quote: {
      seo_title: "Soumission en 30 secondes | Mr Trophée",
      seo_desc: "Demandez votre soumission de trophées en 30 secondes : coordonnées, catalogue, page, produit, quantité — réponse rapide garantie.",
      kicker: "Réponse rapide garantie",
      title_1: "Votre soumission en", title_2: "30 secondes",
      intro: "Parcourez nos catalogues, notez les numéros, et c'est parti — nous vous répondons rapidement avec prix et disponibilité.",
      first_name: "Prénom", last_name: "Nom de famille", organization: "Organisation / club (optionnel)",
      address: "Adresse (numéro et rue)", city: "Ville", postal_code: "Code postal", phone: "Téléphone", email: "Courriel",
      bill_to: "Facturé à", ship_to: "Livrer à", same_as_client: "Même adresse que le dossier client",
      matrice_note: "Frais de matrice : à déterminer — confirmés dans votre soumission (gravure et impression couleur aussi : à déterminer).",
      needed_by: "Pour quelle date ? (livrer avant le)",
      items_title: "Vos choix de produits",
      choice: "Choix nº {n}",
      catalogue: "Quel catalogue ? (si applicable)", product_name: "Nom du produit (hors catalogue)", product_no: "Nº de produit", qty: "Quantité",
      plaquette_page: "Formulaire détaillé de gravure sur mesure →",
      catalogue_ph: "— Choisissez un catalogue —",
      with_text: "Avec inscription (gravure ou impression) ?",
      text_label: "Texte à graver ou imprimer",
      text_ph: "Ex. : Tournoi de golf 2026 — 1re place — Merci à nos commanditaires",
      logo_label: "Logo et fichiers (optionnel — 25 Mo max chacun, plusieurs possibles)",
      logo_btn: "Téléverser un fichier",
      logo_too_big: "Fichier trop lourd — 25 Mo maximum (png, jpg, webp, svg, pdf).",
      logo_too_many: "Maximum 10 fichiers par article.",
      pieces_label: "Pièces jointes (optionnel — elles partent en même temps que la soumission)",
      pieces_hint: "Photos, croquis, exemples, fichiers… 25 Mo max chacune, 10 au maximum.",
      pieces_btn: "Joindre des fichiers",
      pieces_uploaded: "Pièce jointe ajoutée",
      pieces_too_many: "Maximum 10 pièces jointes par soumission.",
      catalogue_required: "Décrivez au moins un article (catalogue + Nº de produit, ou nom du produit hors catalogue).",
      page_or_product: "Pour chaque article : le nom du produit (hors catalogue) OU son Nº de produit — un seul des deux suffit.",
      hint: "* Champs obligatoires — pour chaque article : le nom du produit (hors catalogue) OU son Nº dans un catalogue suffit. Votre demande part directement à notre atelier, aucune création de compte nécessaire.",
      add_item: "Ajouter un produit",
      remove_item: "Retirer",
      submit: "Envoyer ma soumission",
      sending: "Envoi…",
      sent: "Soumission envoyée ! Nous vous répondons très rapidement.",
      fab: "Soumission en 30 secondes",
      fab_long: "Votre soumission en 30 secondes",
    },
    respond: {
      seo_title: "Votre soumission | Mr Trophée",
      seo_desc: "Choisissez vos produits et envoyez votre texte de gravure.",
      title_1: "Votre", title_2: "soumission",
      hello: "Bonjour {name},",
      choice_hint: "Si c'est le cas, cochez la ou les cases de modèle que vous désirez :",
      ship_title: "Vos adresses",
      ship_note: "Ces informations serviront à la facturation et à la livraison de votre commande.",
      ship_billing: "Facturé à",
      bill_same: "Copier l'adresse de ma demande (ci-dessus)",
      bill_name: "Nom complet (facturation)",
      bill_save: "Confirmer mon adresse de facturation",
      bill_saved: "Adresse de facturation enregistrée — merci !",
      bill_confirmed_same: "Adresse copiée de votre demande (confirmée)",
      bill_confirmed_new: "Adresse de facturation confirmée",
      bill_incomplete: "Complétez la rue, la ville et le code postal.",
      ship_to: "Livrer à",
      ship_same: "Même adresse que la facturation",
      ship_name: "Nom du destinataire", ship_address: "Adresse (numéro et rue)",
      ship_address2: "Adresse — ligne 2 (app., bureau…)",
      ship_city: "Ville", ship_province: "Province", ship_postal: "Code postal",
      ship_save: "Confirmer l'adresse de livraison", ship_saving: "Enregistrement…",
      ship_saved: "Adresse de livraison enregistrée — merci !",
      ship_edit: "Modifier", ship_confirmed_same: "Même adresse que la facturation (confirmée)",
      ship_incomplete: "Complétez la rue, la ville et le code postal.",
      intro: "Voici votre soumission détaillée. Choisissez vos produits en cliquant dessus, inscrivez le texte de gravure/impression de chacun, puis téléversez votre logo si désiré.",
      needed_by: "Livraison souhaitée avant le",
      choose_hint: "Cliquez un produit pour le sélectionner ou le retirer.",
      engraving_label: "Texte pour la gravure / impression",
      engraving_ph: "ex. Tournoi des Étoiles 2026 — 1re place",
      method_label: "Type d'inscription souhaité",
      method_laser: "Gravure au laser",
      method_serigraphie: "Impression sérigraphie",
      logo_label: "Vos fichiers — logo, images (optionnel)",
      logo_hint: "Images ou PDF, 25 Mo max chacun — plusieurs fichiers possibles (10 max)",
      logo_uploading: "Téléversement en cours…",
      logo_ok: "Fichier(s) téléversé(s)",
      logo_remove: "Retirer ce fichier",
      logo_too_many: "Maximum 10 fichiers — retirez-en pour en ajouter d'autres.",
      pay: "Payer en ligne",
      paid: "Paiement reçu — merci ! Nous procédons à la production.",
      pay_thanks: "Paiement reçu, merci !",
      pay_account_note: "Compte requis pour payer — connexion ou inscription rapide, et votre commande restera dans votre dossier.",
      pay_login_required: "Connectez-vous ou créez votre compte pour payer — votre commande restera dans votre dossier.",
      global_rabais: "rabais global",
      taxes_title: "Détail avant paiement",
      taxes_subtotal: "Sous-total (rabais déduits)",
      taxes_welcome: "Rabais de bienvenue (infolettre)",
      taxes_tps: "TPS (5 %)",
      taxes_tvq: "TVQ (9,975 %)",
      taxes_total: "Total à payer",
      total_line: "Total de la ligne",
      grand_total: "Total de votre sélection (avant taxes)",
      price_pending_line: "Prix à venir — en cours de préparation par notre équipe",
      price_pending_total: "Les prix seront visibles ici une fois remplis par notre équipe.",
      selected_count: "{n} produit(s) sélectionné(s)",  /* remplacé à l'affichage par le pluriel propre (QuoteRespond) */
      submit: "Confirmer ma sélection",
      sending: "Envoi…",
      sent_title: "Merci ! Votre réponse est bien envoyée.",
      sent_text: "Nous avons reçu votre sélection, vos textes et votre logo. Nous préparons la suite et nous vous contactons très vite.",
      resubmit: "Modifier ma réponse",
      invalid: "Ce lien de soumission est invalide ou expiré. Écrivez-nous à commande@trophee.ca.",
      need_one: "Choisissez au moins un produit.",
      per_unit: "/un.",
      col_product: "Produit", col_engraving: "Gravure-impr.", col_insert: "Insertion",
      col_matrix: "Matrice", col_transport: "Transport",
      refuse_btn: "Refuser la soumission",
      refuse_title: "Refuser la soumission",
      refuse_intro: "Dites-nous en un mot pourquoi — cela nous aide à mieux vous servir. Notre atelier en sera avisé immédiatement.",
      refuse_motif_prix: "Le prix",
      refuse_motif_delai: "Le délai de livraison",
      refuse_motif_annule: "Projet annulé / changement d'idée",
      refuse_motif_autre: "Autre (précisez)",
      refuse_note_label: "Une petite note",
      refuse_note_ph: "ex. Le budget prévu est de…",
      refuse_confirm: "Envoyer mon refus",
      refuse_cancel: "Annuler",
      refuse_need_motif: "Choisissez le motif du refus.",
      refuse_need_note: "Une petite note de motif est obligatoire.",
      refuse_sent_title: "C'est noté — merci de nous avoir répondu.",
      refuse_sent_text: "Nous avons bien reçu votre réponse. Si la situation change, écrivez-nous à commande@trophee.ca — il nous fera plaisir de reprendre votre dossier.",
      refused_notice: "Cette soumission est marquée refusée. Vous avez changé d'idée ? Écrivez-nous à commande@trophee.ca ou renvoyez une réponse ci-dessous.",
      discount_notice: "Bonne nouvelle — un rabais de {pct} % a été appliqué sur les produits et la gravure ! Les prix ci-dessous sont à jour.",
      accept_thanks: "Soumission acceptée — merci ! Choisissez vos produits ci-dessous et envoyez-nous vos textes.",
      accept_confirm_title: "Confirmer votre acceptation",
      accept_confirm_hint: "Pour accepter cette soumission, appuyez sur le bouton ci-dessous — une simple ouverture du courriel ne suffit plus.",
      accept_confirm_btn: "Oui, j'accepte la soumission",
      retire_btn: "Retirer ma soumission",
      retire_title: "Retirer ma soumission",
      retire_intro: "Votre soumission sera retirée et nous cesserons toute relance à son sujet. Dites-nous en quelques mots pourquoi — c'est obligatoire, et ça nous aide à nous améliorer.",
      retire_reason_label: "Pourquoi retirez-vous votre soumission ? *",
      retire_reason_ph: "ex. Le prix ne convient pas, l'événement est annulé, délai trop long, autre…",
      retire_need_reason: "Une petite note est obligatoire — quelques mots suffisent.",
      retire_confirm: "Confirmer le retrait",
      retire_cancel: "Annuler",
      retire_sent_title: "C'est retiré — merci de nous avoir avisés.",
      retire_sent_text: "Votre soumission est retirée et aucune relance ne vous sera plus envoyée. Si la situation change, écrivez-nous à commande@trophee.ca — il nous fera plaisir de reprendre votre dossier.",
      retired_notice: "Cette soumission a été retirée. Un changement de plan ? Écrivez-nous à commande@trophee.ca.",
      counter_title: "Avant de partir…",
      counter_text: "Nous comprenons que le prix compte. Nous vous offrons {pct} % de rabais sur les produits et la gravure — déjà appliqué à votre soumission ci-dessous.",
      counter_accept: "J'accepte le rabais de {pct} %",
      counter_decline: "Non merci, retirer quand même",
      counter_accepted: "Rabais appliqué — vos prix sont à jour. Il ne reste qu'à choisir vos produits !",
    },
    express: {
      title: "Production express",
      desc: "Votre commande passe en priorité à l'atelier — prête en 2 jours ouvrables.",
      fee: "Production express (+{pct} %)",
      badge: "Express",
    },
    home_testimonials: {
      kicker: "Ils nous font confiance",
      title_1: "La parole aux", title_2: "champions",
      rating: "5,0 sur Google",
      google_reviews: "avis Google",
      google_badge: "Avis Google",
      owner_reply: "Réponse du propriétaire",
      see_all_google: "Voir tous les avis sur Google",
      items: [
        { quote: "Mr Trophée se démarque par l'excellence de son service ! La communication est facile, rapide et efficace. C'est un partenaire de confiance dans la région !", author: "Stéphanie Bottier", org: "Avis Google 5 étoiles" },
        { quote: "Je suis très satisfait des services de gravure laser ! Excellente communication, très pratique ! Fortement recommandé.", author: "Pavel Kotov", org: "Avis Google 5 étoiles" },
        { quote: "Excellent service. Rapide et efficace. Disponibilités hors heures d'ouverture. Ne vous fiez pas à ce que vous voyez sur Google. Merci encore !", author: "Catherine Lavoie", org: "Avis Google 5 étoiles" },
        { quote: "Beau travail très rapide et efficace ! Collaboration facile et un super résultat !", author: "Cassandre Orlando", org: "Avis Google 5 étoiles" },
      ],
    },
    home_reviews_banner: {
      fallback: "Nos clients nous recommandent sur Google",
      see: "Voir tous les avis",
    },
    privacy: {
      nav_link: "Confidentialité",
      seo_title: "Politique de confidentialité | Mr Trophée",
      seo_desc: "Comment Mr Trophée collecte, utilise et protège vos renseignements personnels, conformément à la Loi 25 du Québec.",
      kicker: "Vos données, protégées",
      title: "Politique de confidentialité",
      updated: "Dernière mise à jour : 20 septembre 2026",
      sections: [
        { h: "Qui nous sommes", p: "Mr Trophée (Trophée.ca) est un atelier québécois de trophées, médailles, plaques et gravures personnalisées, situé au 1314 ch. du Lac-Saint-Louis, Léry (Québec). Responsable de la protection des renseignements personnels : info@trophee.ca — 514-565-6665." },
        { h: "Vos informations protégées de bout en bout", p: "De votre première visite sur mrtrophee.ca jusqu'à la livraison de votre commande, vos renseignements personnels sont protégés à chaque étape — c'est un engagement :", items: [
          "Connexion chiffrée en tout temps (HTTPS) entre votre navigateur et notre site — aucune information ne circule en clair",
          "Mots de passe hachés : même notre équipe ne peut pas les lire",
          "Paiements entièrement traités par Stripe (certifié PCI-DSS) : vos numéros de carte ne touchent jamais nos serveurs",
          "Accès aux données strictement limité à l'équipe de production qui prépare votre commande",
          "Vos fichiers (logos, images) et vos textes de gravure servent uniquement à produire vos articles — jamais partagés, jamais réutilisés",
          "Aucune vente ni location de vos renseignements personnels — jamais",
        ] },
        { h: "Renseignements que nous collectons", p: "Nous ne collectons que ce qui est nécessaire pour servir votre commande :", items: [
          "Coordonnées du compte : nom, courriel, adresse postale, numéro de téléphone",
          "Détails de commande : produits choisis, inscriptions à graver ou à imprimer, fichiers téléversés (logos, images)",
          "Données techniques : témoins (cookies) de session essentiels au fonctionnement du panier et du compte",
        ] },
        { h: "Comment nous les utilisons", items: [
          "Produire et livrer vos commandes personnalisées",
          "Vous envoyer les courriels liés à votre commande (confirmation, suivi de production, facture)",
          "Vous envoyer notre infolettre, seulement si vous y avez consenti (désabonnement en un clic)",
          "Produire un rapport mensuel de visibilité du site à partir de Google Search Console, en lecture seule — ces statistiques sont anonymes et ne contiennent aucune donnée client",
        ] },
        { h: "Témoins (cookies) et stockage local", p: "Le site utilise très peu de témoins, et aucun à des fins publicitaires ou de pistage par des tiers :", items: [
          "Témoins essentiels (connexion et panier) : nécessaires au fonctionnement du site — ils ne servent à rien d'autre et ne sont jamais partagés",
          "Préférences de votre navigateur : langue choisie, panier en cours, mémorisation de votre abonnement à l'infolettre (pour ne pas vous réafficher le message de bienvenue)",
          "Recherches boutique : vos dernières recherches et catégories visitées restent dans UN témoin de votre navigateur (180 jours) pour vous proposer de meilleurs résultats à votre retour — ce témoin n'est jamais lu par notre serveur ni partagé, et le lien « Effacer » du bloc de suggestions le supprime à tout moment",
          "Mesure d'audience : un identifiant anonyme et aléatoire nous indique les pages visitées (il est effacé automatiquement 10 minutes après votre visite, sans nom ni courriel)",
          "Paiement : la page de paiement est hébergée par Stripe — les témoins éventuels de Stripe restent sur le domaine de Stripe, jamais sur mrtrophee.ca",
          "Aucun témoin publicitaire (Meta, Google Ads) n'est utilisé. Si cela change un jour, votre consentement sera demandé avant, conformément à la Loi 25",
        ] },
        { h: "Paiements", p: "Les paiements en ligne sont traités par Stripe, un fournisseur certifié PCI-DSS. Nous ne voyons ni ne conservons jamais vos numéros de carte de crédit sur nos serveurs." },
        { h: "Partage avec des tiers", p: "Vos renseignements personnels ne sont jamais vendus ni loués. Ils sont communiqués uniquement aux fournisseurs essentiels au service : Stripe (paiement sécurisé), Resend (envoi de courriels transactionnels), Google (affichage des avis publics et statistiques de recherche) et notre hébergeur infonuagique." },
        { h: "Conservation", p: "Nous conservons vos renseignements le temps nécessaire pour fournir nos services et respecter nos obligations comptables et fiscales. Vous pouvez demander la suppression de votre compte et de vos données en tout temps à info@trophee.ca." },
        { h: "Vos droits (Loi 25 du Québec)", p: "Vous avez le droit :", items: [
          "d'accéder aux renseignements que nous détenons sur vous",
          "de demander leur rectification ou leur suppression",
          "de retirer votre consentement à l'infolettre en tout temps",
          "de déposer une plainte auprès de la Commission d'accès à l'information du Québec (CAI)",
        ] },
        { h: "Sécurité et modifications", p: "Le site utilise le chiffrement HTTPS, les mots de passe sont hachés et l'accès aux données est restreint. Toute modification de cette politique sera publiée sur cette page avec sa date de mise à jour." },
      ],
    },
    reco: {
      title: "Reprendre où vous étiez",
      suggestions: "Suggestions pour vous",
      suggestions_generic: "Nos suggestions du moment",
      clear: "Effacer",
      see: "Explorer la boutique",
    },
    terms: {
      nav_link: "Conditions d'utilisation",
      seo_title: "Conditions d'utilisation | Mr Trophée",
      seo_desc: "Les conditions d'utilisation de la boutique en ligne Mr Trophée : commandes, produits personnalisés, paiements, livraison et retours.",
      kicker: "Les règles du jeu",
      title: "Conditions d'utilisation",
      updated: "Dernière mise à jour : 16 octobre 2026",
      sections: [
        { h: "Acceptation", p: "En utilisant le site mrtrophee.ca et en passant une commande, vous acceptez les présentes conditions d'utilisation." },
        { h: "Produits personnalisés", p: "Vous êtes responsable de l'exactitude des textes à graver ou à imprimer (orthographe, dates, noms) et vous garantissez détenir les droits sur tout logo, image ou fichier téléversé. La production démarre après la validation et le paiement de la commande." },
        { h: "Prix et paiement", p: "Les prix sont en dollars canadiens, avant taxes (TPS et TVQ en sus). Les rabais par quantité et les frais de personnalisation sont affichés avant le paiement. Le paiement s'effectue en ligne de façon sécurisée." },
        { h: "Délais de production", p: "La fabrication demande un minimum de 5 jours ouvrables. Une production express est offerte sur demande. Les délais de livraison postale une fois le colis expédié ne sont pas garantis par Mr Trophée." },
        { h: "Livraison et ramassage", p: "La livraison s'effectue par service postal ou messagerie ; la livraison est gratuite au-dessus du seuil affiché à la caisse. Le ramassage à l'atelier de Léry est possible sur rendez-vous." },
        { h: "Annulation et retours", p: "Une commande peut être annulée sans frais avant le début de la production. Les articles personnalisés (gravés ou imprimés) ne sont ni repris ni échangés, sauf en cas de défaut de fabrication ou d'erreur de notre part — dans ce cas, l'article est corrigé, remplacé ou remboursé." },
        { h: "Droits d'auteur — copyright", p: "© Mr Trophée — tous droits réservés. L'ENSEMBLE du site mrtrophee.ca, incluant sans s'y limiter les textes, photos, images, montages visuels (épreuves), descriptions de produits, logos, graphismes, code source et mise en page, est la propriété exclusive de Mr Trophée et est protégé par la Loi sur le droit d'auteur du Canada ainsi que par les traités internationaux.", items: [
          "Il est strictement INTERDIT de copier, reproduire, republier, télécharger, modifier, traduire, vendre ou distribuer TOUT ou PARTIE du site (textes, photos, montages, logo, code) sans notre autorisation ÉCRITE préalable",
          "L'utilisation de nos photos, de nos textes ou de nos montages sur un autre site web, un réseau social ou tout autre support constitue une violation de droits d'auteur passible de poursuites et de réclamations de dommages",
          "Nous surveillons régulièrement le web afin de repérer toute reproduction non autorisée de notre contenu",
          "Pour demander une autorisation d'utilisation : info@trophee.ca",
        ] },
        { h: "Propriété intellectuelle de vos fichiers", p: "Vous conservez tous vos droits sur les fichiers que vous nous transmettez (logos, images, textes) ; ils ne servent qu'à produire votre commande." },
        { h: "Limite de responsabilité", p: "Le site est fourni tel quel. Notre responsabilité relativement à une commande se limite au montant payé pour celle-ci." },
        { h: "Droit applicable", p: "Les présentes conditions sont régies par les lois du Québec et du Canada. Tout différend sera soumis aux tribunaux compétents du Québec." },
        { h: "Contact", p: "Pour toute question : info@trophee.ca ou 514-565-6665. Nous répondons même en dehors des heures d'ouverture." },
      ],
    },
    returns: {
      nav_link: "Politique de retour",
      seo_title: "Politique de retour | Mr Trophée",
      seo_desc: "Politique de retour Mr Trophée : aucun retour sur les articles gravés ou imprimés ; exceptions, annulation avant production et remboursements.",
      kicker: "Clair et sans surprise",
      title: "Politique de retour",
      updated: "Dernière mise à jour : 6 septembre 2026",
      sections: [
        { h: "Articles personnalisés : aucun retour", p: "Tout article gravé ou imprimé (trophées, médailles, plaques, produits promotionnels avec logo ou texte) est fabriqué sur mesure selon vos instructions. Pour cette raison, ces articles ne sont ni repris, ni échangés, ni remboursés. Vérifiez soigneusement l'orthographe, les dates et votre logo avant de payer : ce que vous confirmez est ce que nous produisons." },
        { h: "Exceptions — notre engagement qualité", p: "Nous corrigeons toujours ce qui relève de nous :", items: [
          "défaut de fabrication (gravure ou impression défectueuse)",
          "erreur de notre part (ex. : texte gravé différent de celui confirmé à la commande)",
          "article brisé ou endommagé pendant le transport",
        ] },
        { h: "Comment faire une réclamation", p: "Écrivez à info@trophee.ca ou appelez le 514-565-6665 dans les 14 jours suivant la réception, avec votre numéro de commande et une photo du problème. L'article sera corrigé, remplacé ou remboursé — à notre choix selon le cas — sans frais pour vous." },
        { h: "Annulation d'une commande", p: "Une commande peut être annulée sans frais avant le début de la production. La production démarre rapidement (minimum 5 jours ouvrables) : contactez-nous dès que possible. Une fois la gravure ou l'impression commencée, la commande ne peut plus être annulée." },
        { h: "Articles non personnalisés", p: "Un article acheté sans aucune personnalisation peut être retourné dans les 14 jours suivant la réception, dans son état neuf et son emballage d'origine. Les frais de retour sont à votre charge ; le remboursement couvre le prix de l'article (les frais de livraison initiaux ne sont pas remboursables)." },
        { h: "Remboursements", p: "Tout remboursement approuvé est émis sur le mode de paiement original (carte ou PayPal) dans les 5 à 10 jours ouvrables suivant l'approbation." },
        { h: "Contact", p: "Mr Trophée — 1314 ch. du Lac-Saint-Louis, Léry (Québec) — info@trophee.ca — 514-565-6665." },
      ],
    },
    realisations: {
      kicker: "Nos réalisations",
      title_1: "Des pièces qui", title_2: "marquent les mémoires",
      sub: "Un aperçu des trophées, médailles, plaques et gravures sortis de notre atelier pour des clubs, des entreprises et des municipalités.",
      cta: "Créer la vôtre",
      official: "Notre enseigne officielle — trophee.ca",
      items: [
        { caption: "Gala 2026 — trophées étoile et plaques gravées" },
        { caption: "L'établi de l'atelier — coupes et médailles prêtes à graver" },
        { caption: "Médaille de baseball personnalisée" },
        { caption: "Gravure laser en action dans notre atelier" },
        { caption: "Gravure laser sur verre — souvenir Les Tortues" },
        { caption: "Finition main d'une coupe avant la remise" },
      ],
    },
  },
  en: {
    nav: { home: "Home", catalogue: "The Shop", catalogues: "The Catalogues", plaquettes: "Custom engraving", forfaits: "Tournament Packages", blog: "Blog", craft: "Craftsmanship", realisations: "Our work", about: "About", faq: "FAQ", rdv: "Appointments", contact: "Contact", login: "Sign in", account: "My account", admin: "Administration", logout: "Sign out" },
    rdv: {
      kicker: "Appointments", title_1: "Book an", title_2: "appointment",
      sub: "Book a moment with us — describe what you need, pick a date and time during opening hours. A confirmation is emailed to you.",
      need_account_title: "A complete account is required",
      need_account_sub: "To book, create your account with your name, address, phone number and email — it takes less than a minute.",
      register: "Create my account", login: "I already have an account",
      complete_profile: "Your account is missing information (address or phone) required to book.",
      complete_profile_link: "Complete my account",
      type_title: "Need to talk to someone? Book here.",
      type_libre_placeholder: "E.g.: in-store visit, phone call, urgent engraving…",
      type_libre_hint: "write whatever suits you",
      type_requis: "Please write your appointment type in step 1 to confirm.",
      type_requis_court: "Your appointment type",
      type_boutique: "In-store visit", type_boutique_sub: "Come see us — we'll prepare ideas and samples for you.",
      type_tel: "Phone call", type_tel_sub: "We call you at the number on your account.",
      date_title: "Pick a date",
      slot_title: "Pick a time", minutes: "15 minutes",
      no_slots: "The shop is closed that day — please try another date.",
      ferme_inactif: "Online booking is closed for now — message us on Messenger or call us.",
      ferme_note: "Closed that day",
      libre: "Available", occupe: "Booked", mien: "Your appointment", mien_court: "Yours",
      sujet_label: "Topic of your visit (optional)",
      sujet_placeholder: "E.g.: 40 soccer medals for a tournament…",
      confirm_btn: "Confirm the appointment", confirming: "Confirming…",
      address_shop: "1314 ch. du Lac-Saint-Louis, Léry QC",
      tel_note: "We will call you at",
      success_title: "Appointment confirmed!",
      success_sub: "A confirmation email has been sent and the appointment is on our calendar.",
      another: "Book another appointment",
      my_rdv: "My upcoming appointments", cancel: "Cancel", cancelled: "Appointment cancelled.",
    },
    blog: {
      kicker: "The workshop blog", title_1: "Ideas and", title_2: "advice",
      seo_title: "Blog — Ideas and advice on custom trophies | Mr Trophée",
      seo_desc: "Tips, recognition ideas and behind the scenes at the workshop: everything about custom trophies, medals and engravings in Quebec.",
      read_more: "Read the article", empty: "No articles published yet — come back soon!",
      loading: "Loading articles…", not_found: "Article not found.", back: "Back to the blog",
      share: "Share this article", share_facebook: "Share on Facebook", share_email: "Share by email",
      share_email_hint: "Your email app is opening — otherwise the text is copied: paste it into a new message",
      share_copy: "Copy link", share_copied: "Link copied!", share_sms: "Share by text message",
      share_native: "Share…",
      share_messenger: "Message us on Messenger",
      related: "You may also like",
      shop_title: "Our current favourites",
      shop_cta: "Browse the full shop",
    },
    seo: {
      home_title: "Mr Trophée — Custom trophies, medals and plaques in Quebec",
      home_desc: "Custom trophies, medals and plaques in Quebec. Laser engraving and colour printing, volume pricing, pickup or delivery. Best price guaranteed in Canada.",
      catalogue_title: "Shop online — Trophies, cups, medals and plaques | Mr Trophée",
      catalogue_desc: "Browse our customizable trophies and awards: choose size, quantity and engraving, with volume discounts.",
      catalogues_title: "Our suppliers' online catalogues | Mr Trophée",
      catalogues_desc: "Browse our suppliers' full catalogues — medals, components, plaques and more — and request a custom quote.",
      realisations_title: "Our work — Custom engravings and trophies | Mr Trophée",
      realisations_desc: "Engraved trophies, honour plaques and custom awards for businesses, municipalities and sports organizations.",
      about_title: "About — Trophy and engraving workshop in Léry, Quebec | Mr Trophée",
      about_desc: "Mr Trophée, trophy and laser engraving workshop in Léry (Quebec). Artisanal craftsmanship, fast answers and best price guaranteed in Canada.",
      faq_title: "FAQ — Frequently asked questions | Mr Trophée",
      faq_desc: "Lead times, laser engraving, colour printing, express delivery and volume pricing: everything about your custom trophies.",
      contact_title: "Contact — Mr Trophée in Léry, Quebec",
      contact_desc: "Reach Mr Trophée: 1314 ch. du Lac-Saint-Louis, Léry (Quebec). +1 514-565-6665. We answer even outside business hours.",
      product_suffix: "| Mr Trophée",
    },
    footer: {
      tagline: "Exceptional awards at the best guaranteed price in Canada. High-precision engraving for businesses, municipalities and sports organizations.",
      nav_title: "Navigation", contact_title: "Contact us",
      catalogue: "The Shop", cart: "Cart", account: "My account", register: "Create an account", catalogues: "The Catalogues",
      occasions: "By occasion", villes: "By city", livraison: "Hand delivery", referral: "Refer a friend", badge: "Partner badge",
      location: "1314 Ch. du Lac-Saint-Louis, Léry (Quebec) J6N 1B1",
      phone: "+1 514-565-6665",
      texto: "Text us",
      hours: "We answer even outside business hours",
      rights: "Custom trophies, medals, plaques and engraving.",
      share_page: "Share this page",
    },
    ribbon: ["High-precision laser engraving", "Trophies", "Medals", "Honorary plaques", "Colour printing", "Best price guaranteed in Canada", "Bilingual service"],
    home: {
      hero_kicker: "Montérégie · Quebec — Recognition workshop",
      back_kicker: "Welcome back",
      back_new: "Since your last visit",
      back_products: "new products in the shop",
      back_read: "Read what's new",
      back_shop: "Browse the shop",
      back_hide: "Don't show again",
      hero_l1: "The art of", hero_l2: "victory,", hero_l3: "engraved forever.",
      hero_sub: "Custom trophies, medals and plaques for your competitions, sports teams and businesses. Pick the size, the quantity, then your engraved or printed inscription.",
      cta_collection: "Discover the Shop", cta_craft: "Our craftsmanship",
      cta_catalogues: "Browse our online catalogues",
      collection_kicker: "The collection", collection_title_1: "Exceptional", collection_title_2: "awards",
      pet_tags_kicker: "New — for your companions",
      pet_tags_title_1: "Pet ID tags", pet_tags_title_2: "they'll wear proudly",
      pet_tags_desc: "Paw, dog face or Elegance bone — bright colours and glitter finishes, custom engraving up to 4 lines. Ring or chain included.",
      pet_tags_price_from: "From $14.99",
      pet_tags_price_note: "— engraving: to be determined",
      pet_tags_cta: "Personalize the tag",
      see_all: "Browse the full catalogue", from: "from",
      craft_kicker: "Personalization",
      craft_title_1: "Your inscription,", craft_title_2: "validated by the workshop.",
      craft_cta: "Personalize a trophy",
      craft_plate: "Champions 2026 — Elite League",
      final_title_1: "Ready to honour", final_title_2: "your champions?",
      final_sub: "Volume-based pricing, delivery across Canada.",
      final_cta: "Order now",
      // "L'atelier" section (2026-10-28, SEO audit "thin content") — editable
      // in the admin "Word page" mode
      atelier_kicker: "The workshop — Léry, Montérégie",
      atelier_title_1: "A Quebec workshop,",
      atelier_title_2: "trophies that tell stories",
      atelier_p1: "Since 2002, Mr Trophée has been engraving the milestones of teams, schools and businesses across Quebec. Trophies, cups, medals, honour plaques: every piece is prepared in our Léry workshop, in the Montérégie, with the same care — whether for a weekend hockey tournament or a major corporate gala.",
      atelier_p2: "Laser engraving with tenth-of-a-millimetre precision on metal, glass and wood, colour printing true to your brand, volume pricing: send us your text and logo, we handle the rest. Pickup in Léry, Châteauguay or the area, and delivery anywhere in Canada.",
      atelier_p3: "Our promise in three words: best price guaranteed in Canada, bilingual service, human-to-human answers — a 30-second quote request, and we take care of everything.",
      chapters: [
        { num: "01", title: "The material", text: "Gold-finish metal, cut crystal, solid walnut. Every award begins with a noble material, chosen to last as long as the memory it celebrates." },
        { num: "02", title: "The engraving", text: "High-precision laser engraving or specialized colour printing. We handle your vector files (SVG) and logos, from line tracing to the final product." },
        { num: "03", title: "The moment", text: "Sports tournaments, corporate galas, municipal recognition. A turnkey, remote service with maximum responsiveness — even outside business hours." },
      ],
      features: [
        { title: "Laser engraving", text: "Tenth-of-a-millimetre precision on metal, glass and wood." },
        { title: "Colour printing", text: "Full-colour logos and visuals, true to your brand colours." },
        { title: "Workshop validation", text: "Every inscription is checked by our workshop before production." },
      ],
    },
    catalogue: {
      kicker: "The Shop", title_1: "Choose your", title_2: "award",
      sub: "Every piece is customizable: size, volume pricing, laser engraving or colour printing.",
      loading: "Loading the collection…", from: "from", all: "All",
      empty_category: "No products in this category yet.",
      search_placeholder: "Search trophies, medals, product codes…",
      grid_all: "All categories", grid_count: "{n} products",
      grid_more: "Show more products ({n} left)", grid_empty: "No product matches your search.",
      filter_color: "All colours", filter_size: "All sizes", filter_catalogue: "All catalogues", filter_sport: "All sports", filter_subcat: "All subcategories",
      sort_price_asc: "Price: low to high", sort_price_desc: "Price: high to low", sort_name: "Name (A to Z)",
      grid_from: "From {price}",
      show_more: "Show more products", results: "products",
      page_of: "Page {n} of {total}", goto: "Go", page_label: "Page",
      page_not_found: "No page {n} in this catalogue",
      zoom_in: "Zoom in", zoom_out: "Zoom out", zoom_reset: "Actual size",
      click_hint: "Click any product to open its quick view: size, quantity, personalization (text and logo), then add to cart.",
      view_full: "View full details", prev_page: "Previous page", next_page: "Next page",
      matches: "{n} result(s) — click to jump to the page",
      howto_title: "How to buy",
      howto_steps: [
        "Browse the products or search by name, code or category.",
        "Click a product to open its quick view (or its full page).",
        "Pick the size and quantity — volume discounts apply automatically.",
        "Add your personalization: engraved or printed text, and your logo if you like.",
        "In the cart, send your prefilled quote request — you pay securely online after accepting it.",
      ],
      howto_delays: "Production time: minimum 5 business days after quote acceptance and payment. Need it faster? Contact us — express production available.",
      quote_title: "Quick quote",
      quote_text: "Special project, large quantity or a tight deadline? Write to us: fast answer, even outside business hours.",
      quote_messenger: "Messenger", quote_sms: "Text (SMS)",
      cats: { tous: "All", coupes: "Cups", trophees: "Trophies", medailles: "Medals", plaques: "Plaques",
        verre: "Glass & crystal", acrylique: "Acrylic", cadeaux: "Gifts", hockey: "Hockey",
        resines: "Resins", multisport: "Multisport" },
    },
    category: {
      kicker: "Online shop",
      not_found: "Category not found",
      seo_desc: "Browse our customizable {name}: {n} models, engraving or printing, volume discounts, best price guaranteed in Canada.",
      intro: "{n} models customizable with your logo or text. Volume discounts, production in a minimum of 5 business days, best price guaranteed in Canada.",
    },
    product: {
      back: "Back to catalogue", loading: "Loading…", not_found: "Product not found.",
      admin_preview: "Admin preview — this product is disabled: hidden from customers, visible here to you only.",
      size_title: "Size", color_title: "Colour", finish_title: "Finish", qty_title: "Quantity", tier_applied: "−{pct} % discount applied",
      image_pending: "Image coming soon", load_error: "Product not found or unavailable.",
      zoom_image: "Enlarge photo", zoom_in: "Zoom in", zoom_out: "Zoom out",
      zoom_reset: "Actual size", zoom_close: "Close",
      tier_applied_price: "Tier {min}+: {price} / unit",
      insc_title: "Inscription",
      gravure: "Laser engraving", gravure_hint: "Laser-etched text, metallic finish.",
      impression: "Colour printing", impression_hint: "Full-colour text and logo.",
      arriere: "Back inscription", arriere_hint: "Text engraved or printed on the back.",
      aucune: "No inscription", aucune_hint: "The trophy as is.",
      per_unit: "+ {price} / unit", unit_suffix: "unit", stock_left: "{n} in stock",
      fee_tbd: "To be determined", matrice_fee: "Die (matrix) fee: to be determined",
      tier_grid_title: "Volume pricing by quantity", tier_grid_qty: "Quantity", tier_grid_unit: "Unit price",
      tier_grid_discount: "Discount", tier_grid_base: "Regular price", tier_grid_fee_note: "Engraving/printing fees extra, if selected.",
      bulk_note: "Need a larger quantity?", bulk_note_link: "Contact us for custom pricing.",
      stock_capped: "Quantity adjusted to available stock ({n})",
      min_qty: "Minimum {n} units",
      ready_by: "Ordered today: ready by {date} at the latest (minimum 5 business days of production).",
      setup_fee_note: "Screen charge: {s} on your first order of this item, then {r} on reorders — charged once per order (never per unit).",
      quote_title: "Large quantity?", quote_note: "Beyond {n} units, get custom pricing from our team.",
      quote_cta: "Request a quote",
      tier_grid_quote: "Request a quote",
      quote_popup_title: "Quote request",
      quote_popup_qty: "Target quantity",
      atelier_note_title: "Note for the workshop (optional)",
      atelier_note_placeholder: "Special instructions: logo placement, colours, constraints…",
      ai_kicker: "AI engraving ideas", ai_placeholder: "Describe the occasion (e.g.: hockey tournament, annual gala…)",
      ai_button: "Suggest", ai_note: "Click a suggestion to use it as your engraving text.",
      text_placeholder: "E.g.:\n2026 Champions\nLes Rapides Tournament",
      text_lines_hint: "One text line per line — the workshop will engrave exactly these lines (Line 1, Line 2…).",
      text_lines_max: "Maximum {n} lines",
      color_fiches_title: "Each colour has its own detailed page",
      preview_note: "Indicative preview — the final rendering is validated by our workshop before production.",
      preview_placeholder: "Your inscription here",
      logo_title: "Your logo (optional)",
      logo_cta: "Upload a logo", logo_uploading: "Uploading…",
      logo_formats: "PNG, JPG, SVG, PDF or WebP — 5 MB max",
      logo_remove: "Remove logo", logo_uploaded: "Logo added",
      unit_price: "Unit price", total: "Total ({qty} u.)",
      add_to_cart: "Add to cart", added_toast: "{name} added to cart",
    },
    cart: {
      kicker: "Your selection", title: "Cart", empty: "Your cart is empty.",
      browse: "Browse the catalogue", summary: "Summary", items: "Items",
      delivery: "Delivery", delivery_note: "Confirmed at checkout",
      subtotal: "Subtotal", checkout: "Request my quote",
      account_required: "An account is required to order.",
      gravure: "Laser engraving", impression: "Colour printing", aucune: "No inscription",
      logo: "Logo: {name}",
      atelier_note: "Workshop note",
      color: "Colour",
      complete_title: "Complete your order",
    },
    freeship: {
      remaining: "Only {amount} left for free shipping",
      unlocked: "Free shipping unlocked!",
      hand_hint: "Hand delivery available within {km} km of Léry",
    },
    shared_cart: {
      kicker: "Shared cart",
      title: "A cart ready to order",
      intro: "Someone prepared this selection for you. Review it, add it to your cart and check out — you can still change anything.",
      subtotal: "Subtotal (before taxes and shipping)",
      note: "Prices are recalculated at checkout based on current pricing.",
      add_all: "Add everything to my cart",
      added: "Items added to your cart!",
      not_found: "This shared cart was not found or has expired.",
      go_shop: "Browse the shop",
      share_btn: "Share this cart",
      share_ready: "Cart link ready — share it:",
      with_inscription: "With inscription",
    },
    occasions: {
      kicker: "By occasion",
      title: "Awards for every event",
      intro: "Tournament, gala or year-end: find the perfect award for your occasion, engraved your way.",
      count: "{n} products",
      view: "Browse products",
      back: "All occasions",
      empty: "No products for this occasion yet.",
    },
    villes: {
      kicker: "By city",
      title: "Trophies and medals near you",
      intro: "Laser engraving workshop in Montérégie, fast shipping across Canada: find your city and discover our custom trophies, medals and plaques.",
      view: "View page",
      back: "All cities",
      cta_forfaits: "See tournament packages",
      cta_contact: "Request a quote",
    },
    promo: {
      placeholder: "Promo code (e.g. WELCOME10)", apply: "Apply",
      applied: "Code {code} applied", invalid: "Invalid or expired code",
      auto: "Welcome discount {code} applied automatically — thanks for subscribing to our newsletter!",
      auto_short: "Welcome discount applied automatically (newsletter subscriber)",
      remove: "Remove code", discount: "Discount",
      scope_inscription: "on inscriptions", scope_products: "on products", scope_order: "on the order",
      banner: "{code}: {amount} off {scope}",
      banner_welcome: "Subscribe to our newsletter (news and specials) and receive a welcome discount by email — valid on your first order.",
      banner_hint: "Enter the code in your cart or at checkout",
      banner_cta: "Subscribe to the newsletter",
      banner_cond_inscription: "Offered upon registration",
      banner_cond_distribution: "Offered when you join our mailing list",
      banner_cond_referencement: "Offered to referred customers",
      popup_kicker: "Deal of the day",
      popup_title: "Welcome to Mr Trophée",
      popup_sub: "Two ways to save 10% today:",
      popup_welcome_title: "−10% welcome discount",
      popup_welcome_desc: "Subscribe to our newsletter (news and specials): confirm your subscription by clicking the link in our email, and your welcome discount will be emailed to you — valid on your first order.",
      popup_friend_title: "−10% with REF10",
      popup_friend_desc: "Refer a friend: your referral gets a welcome discount and you receive your personal code.",
      popup_cta: "Shop",
      popup_cta_subscribe: "Subscribe to the newsletter",
      popup_later: "Later",
      popup_newsletter_link: "Subscribe to the newsletter (news and specials)",
      popup_copied: "Code {code} copied!",
      newsletter: {
        placeholder: "Your email",
        cta: "Subscribe",
        success_title: "Check your inbox!",
        success_body: "Click the confirmation link in our email — your welcome code will be sent right after.",
        code_title: "You're already subscribed!",
        code_body: "Here is your welcome code — it was also just emailed to you again.",
        invalid: "Enter a valid email address",
        hint: "News and specials, no spam. Unsubscribe anytime.",
        dialog_title: "Newsletter",
      },
    },
    checkout: {
      kicker: "Final step", title: "Your quote request",
      gate_title: "Create your account to complete your request",
      gate_text: "Registration is required to shop at Mr Trophée — it's free and takes 30 seconds. Your cart is saved: you'll find it exactly as you left it after signing up.",
      gate_register: "Create my account", gate_login: "I already have an account — log in",
      last_name: "Last name", first_name: "First name", company: "Company or club",
      address1: "Address", address2: "Address — line 2 (apt., suite…)",
      city: "City", postal_code: "Postal code", phone: "Phone", email: "Email",
      delivery_label: "Requested delivery date",
      delivery_note: "Allow a minimum of 5 business days for production.",
      delivery_method: "Delivery method", delivery_ship: "Delivery", delivery_ship_desc: "Shipped to your address by carrier",
      delivery_pickup: "Pick up at the workshop", delivery_pickup_desc: "1314 ch. du Lac-Saint-Louis, Léry QC — free",
      delivery_hand: "Hand delivery", delivery_hand_desc: "Personally delivered by Mr Trophée, within {km} km",
      hand_note: "We will contact you to schedule the delivery at your door.",
      hand_tier_under: "Under {km} km", hand_tier_range: "{from} to {to} km",
      beyond_note: "Beyond 50 km: shipped by carrier — delivery within 5 days of proof approval and payment.",
      pickup_note: "We will contact you when your order is ready for pickup.",
      notes_label: "Notes for the workshop",
      notes_placeholder: "Logo to include, engraving details…",
      summary: "Summary", total: "Estimate",
      estimate_note: "Product estimate before personalization — engraving, colour printing and die (matrix) fees: to be determined. The final price is confirmed in your quote, payable online afterwards.",
      pay: "Send my quote request", paying: "Sending…",
      sent_title: "Quote request sent!",
      sent_text: "Your cart and details are in our workshop's hands. You'll receive your detailed quote by email — you can then accept it and pay securely online.",
      method_invalid: "Please complete all required fields before sending.",
      saved_addresses: "My saved addresses", shortcut_active: "Shortcut applied",
      province: "Province", subtotal: "Subtotal (products)", shipping: "Standard shipping", shipping_free: "Free",
      tax_tps: "GST (5 %)", tax_tvq: "QST (9.975 %)", tax_tvh: "HST",
      shop_closed: "The online shop is temporarily closed. Come back soon or contact us.",
      provinces: {
        QC: "Quebec", ON: "Ontario", NB: "New Brunswick", NS: "Nova Scotia",
        PE: "Prince Edward Island", NL: "Newfoundland and Labrador", MB: "Manitoba", SK: "Saskatchewan",
        AB: "Alberta", BC: "British Columbia", NT: "Northwest Territories", NU: "Nunavut", YT: "Yukon",
      },
      secure_note: "No payment now — you pay online after accepting the quote.",
      returns_note: "No returns on engraved or printed items (custom-made).",
    },
    payment: {
      confirming: "Confirming payment…",
      confirming_sub: "We are verifying your transaction with Stripe.",
      confirmed_title: "Thank you, champion.",
      confirmed: "Your payment is confirmed. Our workshop is starting production.",
      order_number: "Order {num}",
      track: "Track my order", catalogue: "Catalogue",
      failed_title: "Payment not confirmed",
      failed: "The payment did not go through. No amount was charged.",
      timeout: "Confirmation is taking longer than expected. Check your account in a few minutes.",
      back_to_cart: "Back to cart",
      cancel_title: "Payment cancelled",
      cancel_sub: "No amount was charged. Your cart is still here.",
    },
    login: {
      kicker: "Member area",
      title: "Sign in", sub: "Access your orders and your account.",
      email: "Email", password: "Password", submit: "Sign in",
      no_account: "No account yet?", create: "Create an account",
    },
    register: {
      title: "Create an account", sub: "Required to order and track your productions.",
      name: "Full name", email: "Email", password: "Password", submit: "Create my account",
      first_name: "First name", last_name: "Last name", phone: "Phone number",
      address: "Full address", city: "City", province: "Province", postal: "Postal code",
      newsletter: "Sign me up for the newsletter to receive our promotions.",
      confirm_password: "Confirm password", password_mismatch: "Passwords do not match.",
      have_account: "Already a member?", login: "Sign in",
    },
    account: {
      hello: "Hello, {name}", title: "My orders",
      none: "No orders yet.", browse: "Discover the Shop",
      delivery: "Requested delivery", total: "Total", loading: "Loading…",
    },
    auth: { google: "Continue with Google", or: "or" },
    verify: {
      banner: "Please confirm your email to activate your account and place orders (check your spam folder).",
      resend: "Resend the email",
      resent: "Confirmation email resent — check your inbox.",
      resend_error: "Unable to send right now, please try again later.",
    },
    confirm: {
      checking: "Confirming your email…",
      success_title: "Email confirmed!",
      success_text: "Your account is now active. You can browse the catalogues and place orders.",
      error_title: "Invalid link",
      error_text: "This confirmation link is invalid or has already been used. Sign in to your account to receive a new one.",
      cta_catalogue: "Browse the shop", cta_login: "Sign in",
    },
    referral: {
      title: "Refer a friend, get −10%",
      text: "Share your link: your referral gets a welcome discount on their first order, and you receive a personal −10% code as soon as their first order is paid.",
      copy: "Copy link", copied: "Link copied!",
      clicks: "Clicks on your link", referred: "Signed-up referrals",
      rewards: "Your thank-you codes", no_rewards: "No rewards yet — share your link!",
      used: "used", valid_until: "valid until",
      note: "You were referred: a welcome discount may apply to your first order.",
      page_kicker: "Referral program",
      how_title: "How it works",
      how_1: "Share your personal link with a club, a business or a friend.",
      how_2: "They create their account through your link and apply code REF10 to their first order.",
      how_3: "Once their order is paid, you receive your personal −10 % code by email.",
      your_code: "Your personal code",
      your_link: "Your referral link",
      filleul_code: "Code to give your referral",
      cta_login: "Log in to get your personal link",
      cta_login_btn: "Log in or create an account",
      page_note: "One use per code, applicable to products only (never engraving or printing). Valid 1 year.",
    },
    badge: {
      page_kicker: "Partner program",
      title: "Show your trophies with pride",
      text: "Did your club, league or business receive awards from our workshop? Add the \"Trophies by Mr Trophée\" badge to your website: copy the code, paste it into your page — that's it.",
      alt: "Custom trophies and medals — Mr Trophée",
      how_title: "How it works",
      how_1: "Pick the badge that best matches your site (dark or light version).",
      how_2: "Copy the matching HTML code with the \"Copy code\" button.",
      how_3: "Paste it into your site's footer or partners page — the badge appears right away.",
      dark_title: "Dark badge — for light websites",
      light_title: "Light badge — for dark websites",
      text_title: "Text link — the simplest version",
      text_link_preview: "Trophies and medals by Mr Trophée — workshop in Léry, Quebec",
      copy: "Copy code", copied: "Code copied!",
      why_title: "Why display it?",
      why_text: "Your members and visitors will know where to order their own awards — and every badge displayed helps our workshop shine across the region. Thank you for your support!",
      cta: "Questions? Write to us",
      note: "No sign-up required: the badge is offered to all our clients and partners.",
    },
    pwd: {
      forgot_link: "Forgot your password?",
      forgot_title: "Forgot password",
      forgot_sub: "Enter your email: if an account exists, a reset link will be sent to you (valid for 1 hour).",
      forgot_send: "Send the link",
      forgot_done: "If an account exists with this email, a reset link has just been sent. Check your inbox (and spam folder).",
      back_login: "Back to sign in",
      reset_title: "New password",
      reset_sub: "Choose your new password.",
      reset_new: "New password",
      reset_confirm: "Confirm password",
      reset_mismatch: "Passwords do not match",
      reset_submit: "Save password",
      reset_done: "Password changed! You are signed in.",
      remember: "Keep me signed in (90 days)",
    },
    status: {
      en_attente_paiement: "Awaiting payment", payee: "Paid", en_production: "In production",
      expediee: "Shipped", livree: "Delivered", annulee: "Cancelled", remboursee: "Refunded",
    },
    shipstatus: {
      created: "Label created", ready: "Ready to ship", in_transit: "In transit", out_for_delivery: "Out for delivery",
      delivered: "Delivered", exception: "Delivery issue", returned: "Returned", cancelled: "Cancelled",
    },
    maintenance: {
      message: "Welcome! Our online shop is temporarily closed for maintenance.",
      cta: "Browse our online catalogues →",
      title: "Under maintenance",
      subtitle: "Our online shop is temporarily closed. Our catalogues remain available — we'll be right back!",
      redirect: "Redirecting to the catalogues in",
      cta_now: "Browse catalogues now",
    },
    account_extra: {
      tracking: "Tracking number",
      profile_title: "My details", first_name: "First name", last_name: "Last name",
      phone: "Phone", email: "Email", save: "Save", profile_saved: "Details saved",
      addresses_title: "My addresses", add_address: "Add an address",
      address_label: "Address name (e.g.: Home, Office)",
      no_addresses: "No saved addresses — they're added automatically with every order.",
      address_added: "Address saved", address_deleted: "Address deleted",
      set_default: "Default address", default_badge: "Default",
      default_saved: "Default address updated",
    },
    about: {
      kicker: "Our story",
      title_1: "The workshop behind", title_2: "every victory",
      p1: "At Mr Trophée, we turn your moments of victory and recognition into lasting memories. High-precision engraving specialists in Montérégie, we craft custom trophies, medals and plaques for businesses, municipalities and sports organizations across Quebec.",
      p2: "Bilingual, turnkey service: from graphic design (logos, line tracing, SVG vector files) to the final product, with laser transfer and specialized printing. Remote projects made simple, with maximum responsiveness — we answer even outside business hours.",
      values: [
        { title: "Best price guaranteed", text: "Exceptional awards at the best guaranteed price in Canada. Find it cheaper elsewhere: we'll match it." },
        { title: "Workshop precision", text: "High-precision laser engraving on metal, glass and wood, and colour printing true to your brand." },
        { title: "Turnkey", text: "Graphic design, vector files, production and delivery: one point of contact for everything." },
      ],
      services_kicker: "Our services",
      services_title_1: "Everything under", services_title_2: "one roof",
      services_sub: "21 in-house services, from graphic design to delivery — at the best guaranteed price in Canada.",
      services: [
        "Custom laser engraving on almost any material",
        "CNC-assisted engraving",
        "Computerized screen printing — brass, aluminum, plastic, acrylic, wood, pens, glass",
        "Specialized engraving inside rings, jewelry and watches",
        "Photo insertion inside a watch",
        "Trophies for every occasion",
        "Signage and door identification",
        "Name tags",
        "Lamicoid plates",
        "Logos and graphic design",
        "Displays and lettering",
        "Screen printing and specialized printing",
        "Large-format printing — banners, signs, coroplast posters",
        "Generic medals",
        "Custom medals made in Quebec",
        "Gala trophies",
        "Series trophies — fast production (200 in 1 week)",
        "Perpetual trophies",
        "Glass engraving",
        "Leather and bottle engraving",
        "Quality cups",
      ],
      cta: "Discover the Shop",
    },
    faq: {
      kicker: "Frequently asked questions", title_1: "Everything to know", title_2: "before ordering",
      items: [
        { q: "What are the production lead times?", a: "Allow a minimum of 5 business days after payment confirmation, depending on quantity and customization. You pick your requested delivery date at checkout and we confirm it by email." },
        { q: "Which files do you accept for logos?", a: "Ideally vector files (SVG, PDF) for a perfect engraving, but we also accept PNG, JPG and WebP. Our team prepares and validates every file before production — at no extra cost." },
        { q: "How do quantity discounts work?", a: "Our house tiers apply automatically: −5% from 6 units, −8% from 12 and −10% from 24 (some products carry their own supplier quantity pricing). Large volume? Contact us for custom pricing." },
        { q: "Laser engraving or colour printing: which should I choose?", a: "Laser engraving etches the material for a permanent, premium metallic look. Colour printing reproduces logos and visuals in full colour. Our workshop validates the rendering before production." },
        { q: "Do you ship across Canada?", a: "Yes. Based in Montérégie, we ship anywhere in Canada. Shipping costs and tracking are confirmed when your order is processed." },
        { q: "How does the best-price guarantee work?", a: "If you find an equivalent product cheaper elsewhere in Canada, write to us with proof: we will match the price." },
      ],
      cta: "Another question?", cta_btn: "Contact us",
    },
    forfaits: {
      kicker: "Turnkey", title_1: "Tournament", title_2: "packages",
      intro: "Medals, trophies and engraving — one clear price per team, calculated live from our catalogue. No math for you: pick your package, we handle the rest.",
      players_label: "Number of players or teams",
      players_unit: "players",
      per_player: "per player",
      min_players: "min. {n} players",
      total: "Estimated total",
      includes: "Includes",
      volume_note: "Prices may vary depending on quantity.",
      popular: "Most popular",
      cta: "Request my quote",
      cta_sub: "Answer within 24 business hours — no obligation",
      form_title: "Your quote in 30 seconds",
      form_name: "Your name", form_phone: "Phone", form_org: "Organization / club", form_city: "City",
      form_sport: "Sport", form_date: "Tournament date (approximate)",
      form_send: "Get my quote", form_sending: "Sending…",
      form_done_title: "Request sent!",
      form_done: "We will call you back shortly with your confirmed price. Thank you for your trust.",
      chosen: "Selected package",
      gate_title: "Create your free account",
      gate_text: "Quotes are reserved for registered customers: yours will be linked to your account, with each product number and its catalogue — simple, error-free tracking.",
      gate_login: "Sign in", gate_register: "Create my account (1 minute)",
      account_line: "Your account",
      seo_title: "Turnkey Tournament Packages — medals, trophies and engraving | Mr Trophée",
      seo_desc: "Custom tournament packages: engraved medals for every player, trophies for the winners, one clear price per team. Quote within 24 h anywhere in Quebec.",
      p1_name: "Bronze", p1_tag: "Every player goes home with a medal",
      p2_name: "Silver", p2_tag: "Medals + the champions' trophy",
      p3_name: "Gold", p3_tag: "A trophy for every player",
      p1_item_medal: "2 in medal — 7/8 in ribbon, front insert with your logo, personalized back inscription",
      p1_item_medal_pl: "2 in medals — 7/8 in ribbon, front insert with your logo, personalized back inscription",
      p2_item_medal: "Medal up to 2.5 in — 7/8 in ribbon, front insert with your logo, personalized back inscription",
      p2_item_medal_pl: "Medals up to 2.5 in — 7/8 in ribbon, front insert with your logo, personalized back inscription",
      p3_item_medal: "Medal up to 3 in — 7/8 in ribbon, front insert with your logo, personalized back inscription",
      p3_item_trophy_each: "Trophy per player — your choice of model",
      p3_item_trophy_each_pl: "Trophies per player — your choice of model",
      item_trophy_choice: "1 team trophy of your choice",
      item_medals: "Engraved medals (ribbon in your club colours)",
      item_trophy_1: "1 engraved trophy for the champion team",
      item_trophy_3: "3 engraved trophies (1st, 2nd and 3rd place)",
      item_plaque: "1 engraved commemorative plaque for the organization",
    },
    livraison: {
      kicker: "Local service",
      title: "Hand delivery* of your products within 50 km of Léry",
      meta: "Hand delivery of engraved trophies, medals and plaques within {radius} km of our Léry workshop (Montérégie): from {fee}, no carrier. Beyond: shipped by carrier, within 5 days of proof approval and payment.",
      intro: "Your engraved trophies, medals and plaques are delivered in person by our team, anywhere within {radius} km of our Léry workshop — including Montreal, the South Shore, Vaudreuil-Soulanges and the Richelieu Valley.",
      beyond: "Beyond 50 km? We ship quickly anywhere in Canada at low prices — best price guaranteed.",
      steps: [
        { h: "You order online", p: "Choose your trophies, medals or plaques — volume discounts from 6 units." },
        { h: "We engrave in Léry", p: "Every piece is personalized in our Léry workshop in Montérégie, with our best price guarantee." },
        { h: "Hand delivery ({radius} km)", p: "Our team delivers your order in person — fees based on distance, no carrier, no lost parcels." },
      ],
      zone_title: "Hand delivery area",
      zone_text: "Anywhere within {radius} km: Montreal, Laval, Longueuil, Brossard, Châteauguay, Saint-Jérôme, Terrebonne, Repentigny and many more. Find yours:",
      cta_villes: "Find your city",
      cta_contact: "Request a quote",
      fee_note: "* Delivery fees extra, based on distance:",
      tier_under: "Under {km} km",
      tier_range: "{from}–{to} km",
      price_note: "Calculated automatically at checkout from your postal code. Free if you prefer pickup at the Léry workshop. Beyond 50 km: shipped by carrier — delivery within 5 days of proof approval and payment.",
      seo_keywords: "trophy hand delivery, trophy delivery Monteregie, medal delivery Lery, trophies delivered in person, local trophy delivery 50 km",
      service_type: "Trophy hand delivery",
    },
    productReviews: {
      title: "Customer reviews", verified: "Verified purchase",
      based_on: "based on", reviews_word: "reviews",
      none: "No reviews yet — be the first customer to share your experience!",
      write: "Write my review", your_rating: "Your rating", your_text: "Your review (minimum 10 characters)",
      send: "Publish my review", sending: "Sending…",
      moderation_note: "Your review will be visible after approval by our team.",
      thanks: "Thank you! Your review will be displayed after moderation.",
      already: "Thank you! You already reviewed this product.",
      pending: "Your review is awaiting moderation — thank you!",
      login_first: "Sign in to leave a review",
      only_buyers: "Only customers who ordered this product can leave a review.",
    },
    forfaitBanner: {
      title: "Tournament season!",
      text: "Medals + trophies + engraving: a turnkey package, one clear price per team.",
      cta: "See the packages", close: "Close banner",
    },
    mySoumissions: {
      title: "My package quotes",
      none: "No quote request yet.",
      players: "players", pending: "Pending", done: "Handled",
      sent_on: "sent on", estimated: "Estimated total",
      new: "New quote request",
    },
    myQuotes: {
      title: "My trophy quotes",
      items: "item(s)", sent_on: "sent on",
      portal: "Open my quote",
      st_attente: "Pending", st_accepte: "Accepted", st_paye: "Paid",
      st_commande: "Ordered", st_expedie: "Shipped", st_livre: "Delivered",
    },
    magicReview: {
      kicker: "Your review in 60 seconds",
      sub: "Personal link tied to your order",
      placeholder: "How was your order? Quality, engraving, delivery…",
      send: "Publish my review",
      thanks_title: "Thank you so much!",
      thanks_text: "Your review will appear on the product page after our team's approval.",
      back_shop: "Back to the shop",
      home: "Back to home",
      seo_title: "Leave my review | Mr Trophée",
    },
    contact: {
      kicker: "Contact", title_1: "Let's talk about", title_2: "your project",
      sub: "A question, a custom quote, a price-match request? Write to us — we answer even outside business hours.",
      first_name: "First name", last_name: "Last name", email: "Email", message: "Your message",
      message_placeholder: "Describe your project: quantity, timeline, type of award…",
      send: "Send the message", sending: "Sending…",
      sent: "Message sent — we will get back to you shortly.",
      references_label: "Catalogue references (optional)",
      references_placeholder: "E.g.: PDU #T-245, Marco No. 3187, quantities…",
      info_title: "Reach us",
      region: "1314 Ch. du Lac-Saint-Louis, Léry (Quebec) J6N 1B1",
      phone: "+1 514-565-6665",
      texto: "Text us",
      hours: "We answer even outside business hours",
      social: "Also reachable on Facebook (Messenger)",
      messenger: "Come chat with us on Messenger",
      call_cta: "Request a call",
      rdv_cta: "Book an appointment",
      call_title: "We'll call you back",
      call_sub: "Leave your number — we call back quickly, even outside business hours.",
      call_phone: "Your phone number",
      call_city: "City",
      call_org: "Organization / club",
      call_city_placeholder: "E.g.: Châteauguay",
      call_postal: "Postal code",
      call_org_placeholder: "E.g.: Minor hockey association of…",
      call_time: "Preferred call time (optional)",
      call_time_placeholder: "E.g.: tonight after 6 pm, tomorrow at noon…",
      call_date: "Preferred date",
      call_from: "From",
      call_to: "To",
      call_subject: "Subject (optional)",
      call_subject_placeholder: "E.g.: trophies for our hockey tournament…",
      call_send: "Request a call",
      call_sent: "Request sent — we will call you back shortly.",
      call_back: "Write a message instead",
    },
    catalogues: {
      kicker: "Supplier catalogues",
      title_1: "Our online", title_2: "catalogues",
      popup_note: "This catalogue opens on the supplier's website, in a new tab.",
      popup_open: "Open the supplier's catalogue",
      intro: "How to order your custom creation? Get a fast, free estimate in just 3 easy steps:",
      cta: "Get my free estimate",
      custom_kicker: "Custom creation",
      custom_title: "Found a model you like? Let's talk.",
      custom_sub: "Send us your references and quantities through your preferred channel — fast reply, even outside business hours.",
      custom_form: "Detailed form",
      viewer_back: "Back to catalogues",
      viewer_external: "Open on the supplier's site",
      viewer_open: "Open the catalogue",
      viewer_share: "Share this catalogue",
      viewer_blocked_kicker: "Supplier catalogue",
      viewer_blocked_text: "This catalogue's supplier does not allow embedded viewing here. Open it full screen in a new tab — your cart and favourites are waiting for you at Mr Trophée.",
      viewer_shop: "Browse products in the shop",
      viewer_help: "Catalogue not displaying? Some suppliers block embedded viewing — use \"Open the catalogue\".",
      viewer_invalid: "This catalogue link is invalid.",
      steps: [
        "Browse our online catalogues below to choose your models.",
        "Note the product references you're interested in, along with the quantities.",
        "Send us your engraving or printing details (or add your logo in SVG/high-resolution format).",
      ],
      groups: [
        {
          title: "Catalogue No. 1 — Trophies, medals, plaques (PDU)",
          links: [
            { label: "Catalogue No. 1.0", url: "https://www.awardsofdistinction.ca/", external: true },
            { label: "Catalogue No. 1.1 (FiveStars)", url: "https://www.fivestarrecognition.ca/" },
            { label: "Catalogue No. 1.2 — Brochures", url: "https://www.awardsofdistinction.ca/awards_brochures.html" },
            { label: "Catalogue No. 1.3 — PDU New Products", url: "https://www.plasticdressup.ca/content/product_spotlight.html" },
            { label: "Catalogue No. 1.4 — Academic", url: "https://www.awardsofdistinction.ca/academic.html" },
            { label: "Catalogue No. 1.5 — Baseball", url: "https://www.awardsofdistinction.ca/baseball.html" },
            { label: "Catalogue No. 1.6 — Basketball", url: "https://www.awardsofdistinction.ca/basketball.html" },
            { label: "Catalogue No. 1.7 — Football", url: "https://www.awardsofdistinction.ca/football.html" },
            { label: "Catalogue No. 1.8 — Fusion", url: "https://www.awardsofdistinction.ca/fusion.html" },
            { label: "Catalogue No. 1.9 — Golf", url: "https://www.awardsofdistinction.ca/golf.html" },
            { label: "Catalogue No. 1.10 — Hockey", url: "https://www.awardsofdistinction.ca/hockey.html" },
            { label: "Catalogue No. 1.11 — Soccer", url: "https://www.awardsofdistinction.ca/soccer.html" },
          ],
        },
        {
          title: "Catalogue No. 2 — Trophies, medals, awards (TR)",
          links: [
            { label: "Catalogue No. 2.0", url: "https://tromartawards.com/nc2023/#p=1" },
          ],
        },
        {
          title: "Catalogue No. 3 — Trophies, medals, plaques (DTC)",
          links: [
            { label: "Catalogue No. 3.0 (Marco Awards 2025)", url: "https://online.fliphtml5.com/zddpr/Marco-Awards-Group-2025-Big-Book/#p=1" },
            { label: "Catalogue No. 3.1 — Tumblers (summer)", url: "https://discounttrophy.ca/wp-content/uploads/2024/01/Flyer-Tumbler-Ete-Summer-3-compresse.pdf" },
            { label: "Catalogue No. 3.2 — Corporate & Gifts", url: "https://online.fliphtml5.com/zddpr/bbue/#p=1" },
            { label: "Catalogue No. 3.3 — Awards & Gifts", url: "https://discounttrophy.ca/wp-content/uploads/2023/07/award-400x518.jpg" },
            { label: "Catalogue No. 3.4 — Golf", url: "http://golf.awardscat.com/#p=1" },
            { label: "Catalogue No. 3.5 — Hockey", url: "https://discounttrophy.ca/wp-content/uploads/2022/11/HOCKEY-2022.pdf" },
            { label: "Catalogue No. 3.6 — Football", url: "https://discounttrophy.ca/wp-content/uploads/2019/08/FOOTBALL.pdf" },
          ],
        },
        {
          title: "Catalogue No. 4 — Trophies, medals, plaques (CR)",
          links: [
            { label: "Catalogue No. 4.0", url: "https://caldwellrecognition.com/catalogs/awards_and_recognition/Index.html#p=1" },
            { label: "Catalogue No. 4.1 — Academic", url: "https://www.awardsandrecognition.ca/catalogs/Academic/index.html#p=1" },
            { label: "Catalogue No. 4.2 — Badminton", url: "https://caldwellrecognition.com/catalogs/Badminton/index.html#p=1" },
            { label: "Catalogue No. 4.3 — Ball Hockey", url: "https://caldwellrecognition.com/catalogs/Ballhockey/index.html#p=1" },
            { label: "Catalogue No. 4.4 — Baseball", url: "https://caldwellrecognition.com/catalogs/Baseball/index.html#p=1" },
            { label: "Catalogue No. 4.5 — Basketball", url: "https://caldwellrecognition.com/catalogs/Basketball/index.html#p=1" },
            { label: "Catalogue No. 4.6 — Billiards", url: "https://www.awardsandrecognition.ca/catalogs/Billiards/index.html#p=1" },
            { label: "Catalogue No. 4.7 — Bowling", url: "https://caldwellrecognition.com/catalogs/Bowling/index.html#p=1" },
            { label: "Catalogue No. 4.8 — Cheerleading", url: "https://www.awardsandrecognition.ca/catalogs/Cheer/index.html#p=1" },
            { label: "Catalogue No. 4.9 — Chess", url: "https://www.awardsandrecognition.ca/catalogs/Chess/index.html#p=1" },
            { label: "Catalogue No. 4.10 — Coach", url: "https://www.awardsandrecognition.ca/catalogs/Coach/index.html#p=1" },
            { label: "Catalogue No. 4.11 — Curling", url: "https://www.awardsandrecognition.ca/catalogs/Curling/index.html#p=1" },
            { label: "Catalogue No. 4.12 — Dance", url: "https://www.awardsandrecognition.ca/catalogs/Dance/index.html#p=1" },
            { label: "Catalogue No. 4.13 — Darts", url: "https://www.awardsandrecognition.ca/catalogs/Darts/index.html#p=1" },
            { label: "Catalogue No. 4.14 — Figure Skating", url: "https://www.awardsandrecognition.ca/catalogs/Figure_Skating/index.html#p=1" },
            { label: "Catalogue No. 4.15 — Football", url: "https://caldwellrecognition.com/catalogs/Football/index.html#p=1" },
            { label: "Catalogue No. 4.16 — Golf", url: "https://caldwellrecognition.com/catalogs/Golf/index.html#p=1" },
            { label: "Catalogue No. 4.17 — Hockey", url: "https://caldwellrecognition.com/catalogs/Hockey/index.html#p=1" },
            { label: "Catalogue No. 4.18 — Equestrian", url: "https://www.awardsandrecognition.ca/catalogs/Horses/index.html#p=1" },
            { label: "Catalogue No. 4.19 — Lacrosse", url: "https://caldwellrecognition.com/catalogs/Lacrosse/index.html#p=1" },
            { label: "Catalogue No. 4.20 — Martial Arts", url: "https://www.awardsandrecognition.ca/catalogs/MartialArts/index.html#p=1" },
            { label: "Catalogue No. 4.21 — Music", url: "https://www.awardsandrecognition.ca/catalogs/Music/index.html#p=1" },
            { label: "Catalogue No. 4.22 — Racing", url: "https://www.awardsandrecognition.ca/catalogs/Racing/index.html#p=1" },
            { label: "Catalogue No. 4.23 — Soccer", url: "https://caldwellrecognition.com/catalogs/Soccer/index.html#p=1" },
            { label: "Catalogue No. 4.24 — Swimming", url: "https://caldwellrecognition.com/catalogs/Swimming/index.html#p=1" },
            { label: "Catalogue No. 4.25 — Tennis", url: "https://caldwellrecognition.com/catalogs/Tennis/index.html#p=1" },
            { label: "Catalogue No. 4.26 — Track & Field", url: "https://www.awardsandrecognition.ca/catalogs/Track/index.html#p=1" },
            { label: "Catalogue No. 4.27 — Volleyball", url: "https://caldwellrecognition.com/catalogs/Volleyball/index.html#p=1" },
          ],
        },
        {
          title: "Catalogue No. 5 — Promotional products (U)",
          links: [
            { label: "Catalogue No. 5.0 (U)", url: "https://www.urbanointernational.com/" },
          ],
        },
        {
          title: "Professional apparel",
          links: [
            { label: "New arrivals 2024/2025", url: "http://s3.amazonaws.com/giant-fashions/file_properties/408/20240409132536867/Giant_Fashions_Stock_Catalog_2024.pdf" },
            { label: "Green Thinking", url: "http://s3.amazonaws.com/giant-fashions/file_properties/408/20240409132327608/Ecorite_2024_Showcase.pdf" },
            { label: "Canada Sportswear", url: "http://s3.amazonaws.com/giant-fashions/file_properties/408/20240410054624988/Canada_Sportswear_2024_Stock_Catalog_2.pdf" },
          ],
        },
      ],
    },
    quote: {
      seo_title: "30-second quote | Mr Trophée",
      seo_desc: "Request your trophy quote in 30 seconds: contact details, catalogue, page, product, quantity — fast reply guaranteed.",
      kicker: "Fast reply guaranteed",
      title_1: "Your quote in", title_2: "30 seconds",
      intro: "Browse our catalogues, jot down the numbers, and go — we'll reply quickly with pricing and availability.",
      first_name: "First name", last_name: "Last name", organization: "Organization / club (optional)",
      address: "Address (street no. and name)", city: "City", postal_code: "Postal code", phone: "Phone", email: "Email",
      bill_to: "Bill to", ship_to: "Ship to", same_as_client: "Same as the customer file address",
      matrice_note: "Die (matrix) fee: to be determined — confirmed in your quote (engraving and colour printing also: to be determined).",
      needed_by: "Needed by which date? (deliver before)",
      items_title: "Your product choices",
      choice: "Choice no. {n}",
      catalogue: "Which catalogue? (if applicable)", product_name: "Product name (not in catalogue)", product_no: "Product no.", qty: "Quantity",
      plaquette_page: "Detailed custom engraving form →",
      catalogue_ph: "— Pick a catalogue —",
      with_text: "With engraving or printing?",
      text_label: "Text to engrave or print",
      text_ph: "E.g.: 2026 Golf Tournament — 1st place — Thanks to our sponsors",
      logo_label: "Logo and files (optional — 25 MB max each, several allowed)",
      logo_btn: "Upload a file",
      logo_too_big: "File too large — 25 MB max (png, jpg, webp, svg, pdf).",
      logo_too_many: "Maximum 10 files per item.",
      pieces_label: "Attachments (optional — they go out with your quote request)",
      pieces_hint: "Photos, sketches, examples, files… 25 MB max each, up to 10.",
      pieces_btn: "Attach files",
      pieces_uploaded: "Attachment added",
      pieces_too_many: "Maximum 10 attachments per quote request.",
      catalogue_required: "Please describe at least one item (catalogue + product no., or a product name not in our catalogues).",
      page_or_product: "For each item: the product name (not in catalogue) OR its product no. — only one of the two is needed.",
      add_item: "Add a product",
      remove_item: "Remove",
      submit: "Send my quote request",
      sending: "Sending…",
      sent: "Quote request sent! We'll reply very quickly.",
      hint: "* Required fields — for each item: the product name (not in catalogue) OR its product no. is enough. Your request goes straight to our workshop, no account needed.",
      fab: "30-second quote",
      fab_long: "Your quote in 30 seconds",
    },
    respond: {
      seo_title: "Your quote | Mr Trophée",
      seo_desc: "Pick your products and send your engraving text.",
      title_1: "Your", title_2: "quote",
      hello: "Hello {name},",
      choice_hint: "If this applies, check the box for each model you would like:",
      ship_title: "Your addresses",
      ship_note: "This information will be used for billing and delivering your order.",
      ship_billing: "Bill to",
      bill_same: "Copy the address from my request (above)",
      bill_name: "Full name (billing)",
      bill_save: "Confirm my billing address",
      bill_saved: "Billing address saved — thank you!",
      bill_confirmed_same: "Address copied from your request (confirmed)",
      bill_confirmed_new: "Billing address confirmed",
      bill_incomplete: "Please complete street, city and postal code.",
      ship_to: "Deliver to",
      ship_same: "Same address as billing",
      ship_name: "Recipient name", ship_address: "Address (street no. and name)",
      ship_address2: "Address — line 2 (apt., suite…)",
      ship_city: "City", ship_province: "Province", ship_postal: "Postal code",
      ship_save: "Confirm delivery address", ship_saving: "Saving…",
      ship_saved: "Delivery address saved — thank you!",
      ship_edit: "Edit", ship_confirmed_same: "Same address as billing (confirmed)",
      ship_incomplete: "Please complete street, city and postal code.",
      intro: "Here is your detailed quote. Pick your products by clicking them, type the engraving/printing text for each, then upload your logo if you like.",
      needed_by: "Requested delivery before",
      choose_hint: "Click a product to select or unselect it.",
      engraving_label: "Engraving / printing text",
      engraving_ph: "e.g. Stars Tournament 2026 — 1st place",
      method_label: "Preferred inscription type",
      method_laser: "Laser engraving",
      method_serigraphie: "Screen printing",
      logo_label: "Your files — logo, images (optional)",
      logo_hint: "Images or PDF, 25 MB max each — several files allowed (10 max)",
      logo_uploading: "Uploading…",
      logo_ok: "File(s) uploaded",
      logo_remove: "Remove this file",
      logo_too_many: "Maximum 10 files — remove some to add more.",
      pay: "Pay online",
      paid: "Payment received — thank you! We're starting production.",
      pay_thanks: "Payment received, thank you!",
      pay_account_note: "Account required to pay — log in or sign up quickly, and your order will stay in your account.",
      pay_login_required: "Log in or create your account to pay — your order will stay in your account.",
      global_rabais: "global discount",
      taxes_title: "Before you pay",
      taxes_subtotal: "Subtotal (discounts applied)",
      taxes_welcome: "Welcome discount (newsletter)",
      taxes_tps: "GST (5%)",
      taxes_tvq: "QST (9.975%)",
      taxes_total: "Total to pay",
      total_line: "Line total",
      grand_total: "Total of your selection (before taxes)",
      price_pending_line: "Price coming — being prepared by our team",
      price_pending_total: "Prices will appear here once filled in by our team.",
      selected_count: "{n} product(s) selected",
      submit: "Confirm my selection",
      sending: "Sending…",
      sent_title: "Thank you! Your response was sent.",
      sent_text: "We received your selection, texts and logo. We're on it and will contact you very soon.",
      resubmit: "Edit my response",
      invalid: "This quote link is invalid or expired. Write to us at commande@trophee.ca.",
      need_one: "Please pick at least one product.",
      per_unit: "/ea.",
      col_product: "Product", col_engraving: "Engraving", col_insert: "Insert",
      col_matrix: "Setup", col_transport: "Shipping",
      refuse_btn: "Decline the quote",
      refuse_title: "Decline the quote",
      refuse_intro: "Tell us why in a few words — it helps us serve you better. Our workshop is notified right away.",
      refuse_motif_prix: "The price",
      refuse_motif_delai: "The delivery time",
      refuse_motif_annule: "Project cancelled / changed my mind",
      refuse_motif_autre: "Other (please specify)",
      refuse_note_label: "A short note",
      refuse_note_ph: "e.g. Our planned budget is…",
      refuse_confirm: "Send my decline",
      refuse_cancel: "Cancel",
      refuse_need_motif: "Please pick a reason.",
      refuse_need_note: "A short note is required.",
      refuse_sent_title: "Noted — thank you for replying.",
      refuse_sent_text: "We received your response. If anything changes, write to us at commande@trophee.ca — we'll gladly reopen your file.",
      refused_notice: "This quote is marked as declined. Changed your mind? Write to commande@trophee.ca or send a new response below.",
      discount_notice: "Good news — a {pct} % discount was applied to products and engraving! Prices below are up to date.",
      accept_thanks: "Quote accepted — thank you! Pick your products below and send us your texts.",
      accept_confirm_title: "Confirm your acceptance",
      accept_confirm_hint: "To accept this quote, press the button below — simply opening the email is no longer enough.",
      accept_confirm_btn: "Yes, I accept this quote",
      retire_btn: "Withdraw my request",
      retire_title: "Withdraw my quote request",
      retire_intro: "Your request will be withdrawn and we will stop all follow-ups about it. Please tell us in a few words why — it is required, and it helps us improve.",
      retire_reason_label: "Why are you withdrawing your request? *",
      retire_reason_ph: "e.g. Price doesn't work, event cancelled, timeline too long, other…",
      retire_need_reason: "A short note is required — a few words are enough.",
      retire_confirm: "Confirm withdrawal",
      retire_cancel: "Cancel",
      retire_sent_title: "Withdrawn — thank you for letting us know.",
      retire_sent_text: "Your request is withdrawn and you will receive no further follow-ups. If things change, write to us at commande@trophee.ca — we will gladly pick your file back up.",
      retired_notice: "This request has been withdrawn. Change of plans? Write to us at commande@trophee.ca.",
      counter_title: "Before you go…",
      counter_text: "We understand price matters. We are offering you {pct}% off products and engraving — already applied to your quote below.",
      counter_accept: "I'll take the {pct}% discount",
      counter_decline: "No thanks, withdraw anyway",
      counter_accepted: "Discount applied — your prices are up to date. Just pick your products!",
    },
    express: {
      title: "Express production",
      desc: "Your order jumps the queue at the workshop — ready in 2 business days.",
      fee: "Express production (+{pct}%)",
      badge: "Express",
    },
    home_testimonials: {
      kicker: "They trust us",
      title_1: "Hear it from the", title_2: "champions",
      rating: "5.0 on Google",
      google_reviews: "Google reviews",
      google_badge: "Google review",
      owner_reply: "Response from the owner",
      see_all_google: "See all reviews on Google",
      items: [
        { quote: "Mr Trophée stands out for the excellence of its service! Communication is easy, fast and efficient. A trusted partner in the region!", author: "Stéphanie Bottier", org: "5-star Google review" },
        { quote: "I am very happy with the laser engraving services! Great communication, very convenient! Highly recommended.", author: "Pavel Kotov", org: "5-star Google review" },
        { quote: "Excellent service. Fast and efficient. Available outside business hours. Don't rely on what you see on Google. Thank you again!", author: "Catherine Lavoie", org: "5-star Google review" },
        { quote: "Beautiful work, very fast and efficient! Easy collaboration and a great result!", author: "Cassandre Orlando", org: "5-star Google review" },
      ],
    },
    home_reviews_banner: {
      fallback: "Our customers recommend us on Google",
      see: "See all reviews",
    },
    privacy: {
      nav_link: "Privacy",
      seo_title: "Privacy Policy | Mr Trophée",
      seo_desc: "How Mr Trophée collects, uses and protects your personal information, in compliance with Quebec's Law 25.",
      kicker: "Your data, protected",
      title: "Privacy Policy",
      updated: "Last updated: September 20, 2026",
      sections: [
        { h: "Who we are", p: "Mr Trophée (Trophée.ca) is a Quebec workshop for custom trophies, medals, plaques and engraving, located at 1314 Ch. du Lac-Saint-Louis, Léry (Quebec). Privacy officer: info@trophee.ca — 514-565-6665." },
        { h: "Your information protected end to end", p: "From your first visit on mrtrophee.ca to the delivery of your order, your personal information is protected at every step — that is our commitment:", items: [
          "Encrypted connection at all times (HTTPS) between your browser and our site — nothing travels in plain text",
          "Hashed passwords: even our team cannot read them",
          "Payments fully processed by Stripe (PCI-DSS certified): your card numbers never touch our servers",
          "Data access strictly limited to the production team preparing your order",
          "Your files (logos, images) and engraving texts are used only to produce your items — never shared, never reused",
          "Your personal information is never sold or rented — ever",
        ] },
        { h: "Information we collect", p: "We only collect what is needed to fulfil your order:", items: [
          "Account details: name, email, mailing address, phone number",
          "Order details: selected products, inscriptions to engrave or print, uploaded files (logos, images)",
          "Technical data: session cookies essential to the cart and account features",
        ] },
        { h: "How we use it", items: [
          "Producing and delivering your custom orders",
          "Sending order-related emails (confirmation, production updates, invoice)",
          "Sending our newsletter, only if you opted in (one-click unsubscribe)",
          "Producing a monthly site visibility report from Google Search Console, in read-only mode — these statistics are anonymous and contain no customer data",
        ] },
        { h: "Cookies and local storage", p: "This site uses very few cookies, and none for advertising or third-party tracking:", items: [
          "Essential cookies (sign-in and cart): required for the site to work — they serve no other purpose and are never shared",
          "Browser preferences: chosen language, current cart, your newsletter subscription (so the welcome message is not shown again)",
          "Shop searches: your latest searches and visited categories stay in ONE cookie in your browser (180 days) to suggest better results when you return — this cookie is never read by our server nor shared, and the \"Clear\" link in the suggestions block deletes it anytime",
          "Audience measurement: an anonymous, random identifier tells us which pages are visited (automatically erased 10 minutes after your visit, with no name or email)",
          "Payment: the checkout page is hosted by Stripe — any Stripe cookies stay on Stripe's domain, never on mrtrophee.ca",
          "No advertising cookies (Meta, Google Ads) are used. Should that ever change, your consent will be requested first, in compliance with Law 25",
        ] },
        { h: "Payments", p: "Online payments are processed by Stripe, a PCI-DSS certified provider. We never see or store your credit card numbers on our servers." },
        { h: "Sharing with third parties", p: "Your personal information is never sold or rented. It is shared only with providers essential to the service: Stripe (secure payment), Resend (transactional emails), Google (display of public reviews and search statistics) and our cloud hosting provider." },
        { h: "Retention", p: "We keep your information as long as needed to provide our services and meet our accounting and tax obligations. You may request deletion of your account and data at any time at info@trophee.ca." },
        { h: "Your rights (Quebec Law 25)", p: "You have the right to:", items: [
          "Access the personal information we hold about you",
          "Request its correction or deletion",
          "Withdraw your newsletter consent at any time",
          "File a complaint with the Commission d'accès à l'information du Québec (CAI)",
        ] },
        { h: "Security and changes", p: "The site uses HTTPS encryption, passwords are hashed and data access is restricted. Any change to this policy will be published on this page with its update date." },
      ],
    },
    reco: {
      title: "Pick up where you left off",
      suggestions: "Suggestions for you",
      suggestions_generic: "Our picks right now",
      clear: "Clear",
      see: "Browse the shop",
    },
    terms: {
      nav_link: "Terms of Service",
      seo_title: "Terms of Service | Mr Trophée",
      seo_desc: "Terms of service for the Mr Trophée online shop: orders, custom products, payments, shipping and returns.",
      kicker: "The rules of the game",
      title: "Terms of Service",
      updated: "Last updated: October 16, 2026",
      sections: [
        { h: "Acceptance", p: "By using mrtrophee.ca and placing an order, you accept these terms of service." },
        { h: "Custom products", p: "You are responsible for the accuracy of the texts to engrave or print (spelling, dates, names) and you guarantee that you own the rights to any logo, image or file you upload. Production starts once the order is confirmed and paid." },
        { h: "Pricing and payment", p: "Prices are in Canadian dollars, before taxes (GST and QST extra). Quantity discounts and personalization fees are shown before payment. Payment is made securely online." },
        { h: "Production times", p: "Manufacturing takes a minimum of 5 business days. Rush production is available on request. Postal delivery times once a parcel is shipped are not guaranteed by Mr Trophée." },
        { h: "Shipping and pickup", p: "Orders ship by postal or courier service; shipping is free above the threshold shown at checkout. Pickup at the Léry workshop is available by appointment." },
        { h: "Cancellation and returns", p: "An order may be cancelled free of charge before production begins. Personalized (engraved or printed) items cannot be returned or exchanged, except in the case of a manufacturing defect or an error on our part — in which case the item is corrected, replaced or refunded." },
        { h: "Copyright", p: "© Mr Trophée — all rights reserved. The ENTIRE mrtrophee.ca website, including without limitation all texts, photos, images, visual mock-ups (proofs), product descriptions, logos, graphics, source code and layout, is the exclusive property of Mr Trophée and is protected by the Copyright Act of Canada and international treaties.", items: [
          "It is strictly FORBIDDEN to copy, reproduce, republish, download, modify, translate, sell or distribute ALL or ANY PART of this site (texts, photos, mock-ups, logo, code) without our prior WRITTEN permission",
          "Using our photos, texts or mock-ups on another website, social network or any other medium is a copyright infringement that may lead to legal action and damage claims",
          "We regularly monitor the web to detect any unauthorized reproduction of our content",
          "To request permission to use our content: info@trophee.ca",
        ] },
        { h: "Intellectual property of your files", p: "You retain all rights to the files you send us (logos, images, texts); they are used only to produce your order." },
        { h: "Limitation of liability", p: "The site is provided as is. Our liability for an order is limited to the amount paid for that order." },
        { h: "Applicable law", p: "These terms are governed by the laws of Quebec and Canada. Any dispute will be submitted to the competent courts of Quebec." },
        { h: "Contact", p: "Questions? info@trophee.ca or 514-565-6665. We answer even outside business hours." },
      ],
    },
    returns: {
      nav_link: "Return Policy",
      seo_title: "Return Policy | Mr Trophée",
      seo_desc: "Mr Trophée return policy: no returns on engraved or printed items; exceptions, cancellation before production and refunds.",
      kicker: "Clear and simple",
      title: "Return Policy",
      updated: "Last updated: September 6, 2026",
      sections: [
        { h: "Personalized items: no returns", p: "Any engraved or printed item (trophies, medals, plaques, promotional products with a logo or text) is custom-made to your instructions. For this reason, these items cannot be returned, exchanged or refunded. Please carefully check spelling, dates and your logo before paying: what you confirm is what we produce." },
        { h: "Exceptions — our quality commitment", p: "We always make right what is our responsibility:", items: [
          "manufacturing defect (faulty engraving or printing)",
          "an error on our part (e.g.: engraved text differs from the one confirmed at checkout)",
          "item broken or damaged during shipping",
        ] },
        { h: "How to make a claim", p: "Write to info@trophee.ca or call 514-565-6665 within 14 days of receiving your order, with your order number and a photo of the problem. The item will be corrected, replaced or refunded — at our discretion — at no cost to you." },
        { h: "Cancelling an order", p: "An order can be cancelled free of charge before production begins. Production starts quickly (minimum 5 business days): contact us as soon as possible. Once engraving or printing has started, the order can no longer be cancelled." },
        { h: "Non-personalized items", p: "An item purchased without any personalization may be returned within 14 days of receipt, in new condition and original packaging. Return shipping costs are at your expense; the refund covers the item price (initial shipping fees are non-refundable)." },
        { h: "Refunds", p: "Any approved refund is issued to the original payment method (card or PayPal) within 5 to 10 business days of approval." },
        { h: "Contact", p: "Mr Trophée — 1314 Ch. du Lac-Saint-Louis, Léry (Quebec) — info@trophee.ca — 514-565-6665." },
      ],
    },
    realisations: {
      kicker: "Our work",
      title_1: "Pieces that", title_2: "leave a mark",
      sub: "A glimpse of the trophies, medals, plaques and engravings that left our workshop for clubs, businesses and municipalities.",
      cta: "Create yours",
      official: "Our official brand — trophee.ca",
      items: [
        { caption: "2026 Gala — star trophies and engraved plaques" },
        { caption: "The workshop bench — cups and medals ready for engraving" },
        { caption: "Custom baseball medal" },
        { caption: "Laser engraving in action in our workshop" },
        { caption: "Laser engraving on glass — Les Tortues souvenir" },
        { caption: "Hand-finishing a cup before the ceremony" },
      ],
    },
  },
};
